import { Injectable } from '@angular/core';
import { APP_CONFIG, Region } from '../../environment';
import { OrderMapper } from './order.mapper';
import { HttpProvider } from '../http/http';
import { IOrderEntity } from '../../model/api/order/order.entity.interface';
import { ICreateOrderResponseEntity } from '../../model/api/order/create-order-response.entity.interface';
import { ICancelOrderResponseEntity } from '../../model/api/order/cancel-order-response.interface';
import { ICancelOrderRequest } from '../../model/models/order/cancel-order-request.interface';
import { DelayedOrderPost, IOrder } from '../../model/models/order/order-interface';
import { IEtaBadge } from '../../model/models/order/eta-badge.interface';
import { VopConsent } from '../../model/types/vop-type';
import { ICreateOrderResponse } from '../../model/models/order/create-order-response';
import { IValidateOrderResponse } from '../../model/models/order/validate-order-response.interface';
import { ICancelOrderResponse } from '../../model/models/order/cancel-order-response.interface';
import { MissingTransactionInfoType } from '../../model/types/missing-transaction-info-type';
import { DirectBankBrand, PaymentMethodType, PaymentMethodTypeID, PayNearMeBrand, StagedRiaBrand } from '../../model/types/payment-method-type';
import { AgentProvider } from '../../providers/agent/agent';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { RouteProvider } from '../../providers/route/route';
import { IRecipient } from '../../model/models/recipient';
import { RecipientProvider } from '../../providers/recipient/recipient';
import { ErrorCodeType } from '../../model/types/error-code-type';
import { TranslateService } from '@ngx-translate/core';
import { PaymentProvider } from '../../providers/payment/payment';
import { AlertController, Events, Platform, ViewController } from 'ionic-angular';
import { LoadingProvider } from '../../providers/loading/loading';
import { Transaction, TransactionInfo, TransactionViewType } from '../../model/myria/app/transaction';
import { COUNTRY_SETTINGS, COUNTRY_SETTINGS_ENABLE_VALUE, DELIVERY_METHOD, EVENTS_NAME, PROMOTION_TYPE, REGISTRATION_FIELDS_ID } from '../myria/app-variables';
import { AnalyticsEventType, SegmentLocationNames, AnalyticsPaymentMethodData, DirectBankVendorType, StagedVendorType, AnalyticsPayoutMethodType, UserLoggingStatus, ContactModalReasons, PayoutAgentType, PendingTransferCancellationSource, OpenBankingBrand } from '../../model/types/analytics.const';
import { SegmentProvider } from '../analytics/segment';
import { getCampaignAnalyticsData, getSourceAnalyticsData } from '../../providers/analytics/deeplink-source';
import { DeliveryMethodType, InstantDeliveryTypes } from '../../model/types/delivery-method-type';
import { LoggerProvider, LoggerEvent } from '../logger/logger';
import { StorageProvider } from '../storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { LoginProvider } from '../myria/login-provider';
import { CallProvider } from '../../providers/call/call';
import { TransactionPreview } from '../../model/myria/app/transactionPreview';
import { DestinationLocation } from '../../model/myria/app/DestinationLocation';
import { DeliveryMethod } from '../../model/myria/app/DeliveryMethod';
import { Beneficiary } from '../../model/myria/app/beneficiary';
import { Country } from '../../model/myria/app/country';
import { regions } from '../../environment/region/regions';
import { IOrderPendingEntity } from '../../model/api/order/order-pending.entity.interface';
import { CashPayoutType } from '../../model/types/cash-payout-type';
import { IPromotionObject } from '../../model/types/promotionobject-type';
import { AgentMapper } from '../../providers/agent/agent.mapper';
import { ICachedStrorageOrder } from '../../model/models/order/order-cached-storage.interface';
import { ResourceProvider } from '../../providers/resource/resource';
import { v4 as uuidv4 } from 'uuid';
import { ICardScanRequest, ICardScanResponse } from '../../model/api/order/card-scan.interface';
import { ICompleteOtpCheckOrderResponse, ICompleteOtpCheckOrderRequest } from '../../model/api/order/complete-otp-check-order-response.interface';
import { MobileWalletProvider } from '../mobile-wallet/mobile-wallet-provider';
import { CustomersProvider } from '../../providers/myria/customer-provider/customers-provider';
import { PromoProvider } from '../promo/promo';
import { PriceCalculatorProvider } from '../price-calculator/price-calculator';
import { FeatureFlagTypes, UtilsProvider } from '../myria/utils-provider';
import { IAgent } from 'model/models/agent';
import { DocUploadType, DocUploadStatus } from '../../model/types/doc-type';
import { HomeScreenProvider } from '../../providers/homescreen/homescreen';
import { AccountFormatPatterns } from '../../model/types/account-format-patterns';
import { FormFieldMergeTransformer } from '../formbuilder/form-field-merge-transformer';
import { isCurrencyAllowedForCustomer } from '../../utils/stablecoin-mvp';
import { IdentityVerificationProvider } from '../identity-verification/identity-verification';
import { KycRequirementReasonType } from '../../model/types/kyc-requirement-reason-type';
import { CustomerIdentificationProcessorType } from '../../model/types/customer-identification-processor-type';
import { VpaFormProvider } from '../vpa-form/vpa-form';

declare var Accertify: any;


@Injectable()
export class OrderProvider {
  order: IOrder;
  payNowTransaction;
  orderMissing: MissingTransactionInfoType;
  proofOfFundsDocName: string = null;

  txnStatusPromise;
  checkStatCounter;
  creatingOrder = false;

  validOrder = false;
  validPayment = false;
  validDelivery = false;
  validRecipient = false;

  schemePaymentEnabled: boolean = false;
  bankPaymentEnabled: boolean = false;

  allowCheckKycInfoOverride: boolean = true;
  lastCardAccounts = {};
  lastCardAccountsPromise = null;
  cancelledACHOrders = [];
  trackedOrderNumbers: string[] = [];

  static AccertifyTransactionPromise: Promise<any> | null = null;
  static AccertifyTransactionID = null;
  pspRedirectResultHandled: boolean = false;
  has3dsRedirect: boolean = false;

  exchangeRateChangedFlag: boolean = false;

  constructor(private httpProvider: HttpProvider,
              private agentProvider: AgentProvider,
              private routeProvider: RouteProvider,
              private recipientProvider: RecipientProvider,
              private translate: TranslateService,
              private paymentProvider: PaymentProvider,
              private alertCtrl: AlertController,
              private loadingProvider: LoadingProvider,
              private analytics: SegmentProvider,
              private storage: StorageProvider,
              private loginProvider: LoginProvider,
              private platform: Platform,
              private callProvider: CallProvider,
              private mobileWalletProvider: MobileWalletProvider,
              private resourceProvider:ResourceProvider,
              private customersProvider: CustomersProvider,
              private calcProvider: PriceCalculatorProvider,
              private utilsProvider: UtilsProvider,
              private homescreenProvider: HomeScreenProvider,
              private promoProvider: PromoProvider,
              private identityProvider: IdentityVerificationProvider,
              private events: Events,
              private vpaFormProvider: VpaFormProvider,
              ) { }

  async initializeOrders() {
    this.logout();
    const order = await this.storage.get(StorageType.PendingOrder);
    if (order) {
      try {
        this.order = JSON.parse(order);
      }
      catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to get pending order from storage');
      }
    }
  }

  logout() {
    this.order = null;
    this.orderMissing = null;
    this.cancelledACHOrders = [];
    this.trackedOrderNumbers = [];
    this.lastCardAccounts = {};
    this.lastCardAccountsPromise = null;
    this.allowCheckKycInfoOverride = true;
    this.checkValidOrder();
    this.clearAccertifyTransactionID();
    this.setExchangeRateChanged(false);
  }

  private getCachedOrderKey(): string {
    const customerId = this.httpProvider.getAuthCustomerId() || 'guest';
    return `${customerId}_${StorageType.CachedPreConfrimOrder}`;
  }

  async cachePreConfirmOrder(order: IOrder) {
    const cachedOrder: ICachedStrorageOrder = {
      countryTo: order.countryTo,
      deliveryMethodInternal: order.deliveryMethodInternal,
      paymentMethod: order.paymentMethod,
      amountFrom: order.amountFrom,
      currencyTo:order.currencyTo
    };

    this.storage.set(this.getCachedOrderKey(), JSON.stringify(cachedOrder));
  }

  resetCachePreConfirmOrder() {
    this.storage.set(this.getCachedOrderKey(), null);
  }

  async getCachePreConfirmOrder() {
    const currentKey = this.getCachedOrderKey();
    let orderStringified = await this.storage.get(currentKey);

    if (!orderStringified) {
      orderStringified = await this.migrateCachedOrder(currentKey);
    }

    return orderStringified ? JSON.parse(orderStringified) : null;
  }

  private async migrateCachedOrder(currentKey: string): Promise<string | null> {
    // Migrate from legacy key (without customerId prefix)
    let orderStringified = await this.storage.get(StorageType.CachedPreConfrimOrder);
    if (orderStringified) {
      await this.storage.set(currentKey, orderStringified);
      await this.storage.remove(StorageType.CachedPreConfrimOrder);
      return orderStringified;
    }

    // Migrate from guest key when user has authenticated
    const guestKey = `guest_${StorageType.CachedPreConfrimOrder}`;
    if (currentKey !== guestKey) {
      orderStringified = await this.storage.get(guestKey);
      if (orderStringified) {
        await this.storage.set(currentKey, orderStringified);
        await this.storage.remove(guestKey);
        return orderStringified;
      }
    }

    return null;
  }

  async storeOrder(page: INavInfo, title: string, text: string) {
    this.order.customerId =  this.httpProvider.getAuthCustomerId();
    this.order.lastExchangeRate = this.order.exchangeRate;
    this.order.activityDetails = {
      page: page,
      title: title,
      text: text
    };
    LoggerProvider.info(this, 'Set stored order', JSON.stringify(this.order)); // TODO security ?
    this.storage.set(StorageType.StoredOrder, JSON.stringify(this.order)); // TODO security ?
    this.storage.set(StorageType.PendingOrder, null);
  }

  resetStoreOrder() {
    LoggerProvider.info(this, 'Reset stored order');
    this.storage.set(StorageType.StoredOrder, null);
  }

  async getStoredOrder() {
    const order = await this.storage.get(StorageType.StoredOrder);
    if (order) {
      try {
        const parsed = JSON.parse(order);
        const customerId = this.httpProvider.getAuthCustomerId();
        if (parsed.customerId === customerId)
          return parsed;
      }
      catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to get stored order from storage');
      }
    }
    return null;
  }

  setCurrentOrder(order: IOrder, updatePendingOrder = true) {
    if (!order)
      this.promoProvider.logout();

    this.order = order;
    if (this.order)
      this.order.customerId = this.httpProvider.getAuthCustomerId();
    if (this.order)
    {
      this.order.lastUpdate = new Date().getTime();
      if (updatePendingOrder) {
        this.order.displayedReminder = false;
        this.updatePendingOrder(this.order);
      }
    }
    return this.checkValidOrder();
  }

  updatePendingOrder(order) {
    // TODO more security ?
    const orderCopy = JSON.parse(JSON.stringify(order));
    if (orderCopy.cardAccount)
      orderCopy.cardAccount.cvn = null;
    // bankDepositProvider is persisted on purpose: a resumed order goes straight to summary and
    // confirms the transaction it already created, so dropping it would send the smart-routed
    // correspondent on agentTo with IsSmartRouting false and no providerId.
    return this.storage.set(StorageType.PendingOrder, JSON.stringify(orderCopy));
  }

  async removePendingOrder() {
    try {
      await this.storage.remove(StorageType.PendingOrder);
      LoggerProvider.info(this, 'Pending Order Removed');
    }
    catch(ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to remove stored order from storage');
    }
  }

  async getFintocStatus(order:IOrder,exttransactionId: string){
    const result = await this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct/fintoc/status`, {
      correlationId:uuidv4(),
      transactionId: order.transactionId,
      orderNo: order.orderNumber,
      exttransactionId: exttransactionId
    })
    if (result && result.status){
      return result.status;
    }
    throw new Error('Invalid Fintoc Status result');
  }

  async initiateFintoc(order: IOrder) {
    const result = await this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct/fintoc/initiate`, {
      orderNumber: order.orderNumber,
      transactionId: order.transactionId,
      correlationId:uuidv4()
    })

    const widget = {
      holderType: 'individual',
      widgetToken: result.widget_token,
      publicKey: APP_CONFIG.FintocPublicKey,
      product: 'payments',
      id: result.id
    }

    if (widget && widget.widgetToken) {
      return widget;
    }

    throw new Error('Invalid Fintoc initiate result');
  }

  async setFintocOrderCancellation (order: IOrder){
    const result = await this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}incompleteorder/cancel`, {      
      orderNumber: order.orderNumber,
    })
    if (result && result.status){
      LoggerProvider.info(this, "Fintoc Order has been cancelled");
     return result;
    } else {
      throw new Error('Invalid Fintoc cancel result');
    }
  }

  getCurrentOrder(): IOrder {
    return this.order;
  }

  // Records the SEPA VoP decision on the order so order/validate can send it.
  setVopConsent(consent: VopConsent, fingerprint?: string) {
    if (this.order) {
      this.order.vopConsent = consent;
      this.order.vopFingerprint = fingerprint || undefined;
      this.setCurrentOrder(this.order);
    }
  }

  async getPendingOrder(maxAge = 0) {
    const order = await this.storage.get(StorageType.PendingOrder);
    if (order) {
      try {
        const parsed = JSON.parse(order);
        if (parsed && parsed.customerId === this.httpProvider.getAuthCustomerId() &&
            (parsed.amountFrom || parsed.amountTo) &&
            (parsed.recipient || parsed.orderStarted) &&
            !parsed.orderSent) {
          if (maxAge <= 0)
            maxAge = 60 * 60 * 24; // 24 hours
          const timePassed = (new Date().getTime() - parsed.lastUpdate)/1000.0;
          if (timePassed >= maxAge) {
            LoggerProvider.info(this, 'Ignoring pending order since it is older than ' + maxAge + ' seconds (' + timePassed + ' seconds)');
            return null;
          }
          return parsed;
        }
      }
      catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to get pending order from storage');
      }
    }
    return null;
  }

  setMissingTransactionInfo(missing: MissingTransactionInfoType) {
    this.orderMissing = missing;
  }

  getMissingTransactionInfo(): MissingTransactionInfoType {
    return this.orderMissing;
  }


  setExchangeRateChanged(changed: boolean) {
    this.exchangeRateChangedFlag = changed;
  }

  getExchangeRateChanged(): boolean {
    return this.exchangeRateChangedFlag;
  }

  // Single source of truth for handling errors thrown by validateOrder().
  // Call from every catch around an /order/validate request — returns `true`
  // when the error was fully handled (the caller must then short-circuit:
  // `if (this.orderProvider.handleValidateError(ex)) return;`) and `false`
  // when the caller should run its own fallback UX.
  //
  // Currently routes:
  //   ErrorCodeType.ExchangeRateChanged → set the flag + pop back to
  //     SendSummaryPage, where the rate-change modal is shown on re-entry.
  //   Foreign-IP identity restriction (RequiresIdentityVerification +
  //     ForeignIpRestriction + IdologyAutoProfile) → open the Idology verify
  //     page. Mirrors the send-finish handleOrderException branch so PSP /
  //     Apple Pay / change-payment-method validate paths get the same UX.
  //   ErrorCodeType.AgentNotFound on an Office / Cash Pickup order → pop back to
  //     SendSummaryPage and offer the location list (payout location missing
  //     or disabled).
  //
  // Add new errorCode → UX mappings here rather than duplicating logic into
  // each catch site, otherwise PSP / Apple Pay / change-payment-method paths
  // drift apart again.
  handleValidateError(ex): boolean {
    if (!ex) return false;

    // Keyed off ex.error (not errorCode), so check before the errorCode guard.
    const errorData = ex.error;
    if (errorData
        && errorData.missingTransactionInfo === MissingTransactionInfoType.RequiresIdentityVerification
        && errorData.kycRequirementReasons
        && errorData.kycRequirementReasons.includes(KycRequirementReasonType.ForeignIpRestriction)
        && errorData.kycProcessor === CustomerIdentificationProcessorType.IdologyAutoProfile) {
      LoggerProvider.info(this, 'Foreign-IP identity restriction during validate (handled by OrderProvider.handleValidateError)');
      this.identityProvider.showIdologyVerifyPage();
      return true;
    }

    const currentOrder = this.getCurrentOrder();
    if (errorData
        && errorData.missingTransactionInfo === MissingTransactionInfoType.VirtualPaymentAccountInfo
        && currentOrder
        && this.vpaFormProvider.isVpaFormDeliveryMethod(currentOrder.deliveryMethodInternal)) {
      LoggerProvider.info(this, 'Missing virtual payment account during validate (handled by OrderProvider.handleValidateError)');
      this.presentVpaFormForMissingKey(currentOrder);
      return true;
    }
    if (errorData
        && errorData.missingTransactionInfo === MissingTransactionInfoType.VirtualPaymentAccountInfo
        && currentOrder
        && currentOrder.deliveryMethodInternal === DeliveryMethodType.PagoMovil
        && currentOrder.recipient) {
      LoggerProvider.info(this, 'Missing PagoMovil account during validate (handled by OrderProvider.handleValidateError)');
      this.presentBankDepositFormForMissingKey(currentOrder);
      return true;
    }

    if (!ex.errorCode) return false;
    if (ex.errorCode === ErrorCodeType.ExchangeRateChanged) {
      LoggerProvider.info(this, 'Exchange rate changed during validate (handled by OrderProvider.handleValidateError)');
      this.setExchangeRateChanged(true);
      if (this.routeProvider.hasPage(this.routeProvider.pages.SendSummaryPage))
        this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
      return true;
    }
    // The payout location is missing or disabled. Back to the summary so the location list
    // replaces it and the customer picks another one. Only pickup orders have a location to pick, and the
    // location list replaces the top page, so without the summary in the stack the caller's fallback runs.
    if (ex.errorCode === ErrorCodeType.AgentNotFound && this.isPickupOrder(currentOrder) && this.routeProvider.hasPage(this.routeProvider.pages.SendSummaryPage)) {
      LoggerProvider.info(this, 'Agent location not available during validate (handled by OrderProvider.handleValidateError)');
      this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
      this.showAgentNotFoundError(!!currentOrder.resend);
      return true;
    }
    return false;
  }

  isPickupOrder(order: IOrder): boolean {
    return !!order && (order.deliveryMethodInternal === DeliveryMethodType.OfficePickup || order.deliveryMethodInternal === DeliveryMethodType.CashPickup);
  }

  private async presentVpaFormForMissingKey(order: IOrder) {
    const opened = await this.vpaFormProvider.openForMissingKey(order,
      (updatedOrder) => {
        this.setCurrentOrder(updatedOrder);
        this.returnToSendSummary();
      },
      () => this.returnToSendSummary());
    if (!opened)
      RmtPopupComponent.showExceptionWithLogTranslation(this, null, 'global.errorGeneralMessage', 'global.errorGeneralHeader');
  }

  private async presentBankDepositFormForMissingKey(order: IOrder) {
    await this.routeProvider.push(this.routeProvider.pages.BankDepositPage, {
      country: order.countryTo,
      amount: order.amountFrom,
      currency: order.currencyTo,
      recipient: order.recipient,
      order,
      bankNameFieldHidden: true,
      dismissOnSave: false,
      isModeUpdateBankDepositDetails: true,
      onSave: async (bank) => {
        try {
          if (!(await bank.save(order.recipient)))
            return;
        } catch (ex) {
          RmtPopupComponent.showException(this, ex, ex.errorMessage);
          return;
        }
        this.returnToSendSummary();
      },
      onBackCallback: async () => this.returnToSendSummary(),
    });
  }

  private returnToSendSummary() {
    if (this.routeProvider.hasPage(this.routeProvider.pages.SendSummaryPage))
      this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
    else
      this.routeProvider.popTo(this.routeProvider.pages.TabsHomeActivityPage);
  }

  async initializeAccertify() {
    // IMPORTANT
    // In Peter Haddads tests we found out that Accertify can sometimes fail when it's called directly at the start
    // It seems it was related when having a slow connection in emulator while other plugins needs to be initialized at the startup
    // because with the slow internet connection the "startWith" inside of the "MMEWrapper" would timeout
    // Hence we call initializeAccertify at a few other points (signin, order validate) to ensure we get an AccertifyDeviceId even when it initially failed
    const accertifyId = await this.getAccertifyTransactionId();

    if (accertifyId)
      return;

    if (!this.platform.is('cordova'))
      return;

    if (OrderProvider.AccertifyTransactionPromise) {
      LoggerProvider.info(this, "Accertify: Waiting for transaction promise to resolve");

      await OrderProvider.AccertifyTransactionPromise;

      if (OrderProvider.AccertifyTransactionID) {
        LoggerProvider.info(this, `Accertify: Transaction ID received: ${OrderProvider.AccertifyTransactionID}`);
        return;
      }

      LoggerProvider.info(this, "Accertify Transaction ID not found, retrying initialization");
    }

    OrderProvider.AccertifyTransactionPromise = new Promise(async (resolve) => {
      try {
        this.clearAccertifyTransactionID();

        LoggerProvider.info(this, "Accertify: Cleared previous Transaction ID");
        LoggerProvider.info(this, "Accertify: Attempting initialization");

        Accertify.start((response) => {
          LoggerProvider.info(this, `Accertify: Initialization successful. Response: ${response}`);

          Accertify.sendDeviceData((transactionId) => {
            LoggerProvider.info(this, `Accertify: Successfully sent device data. Transaction ID: ${transactionId}`);

            OrderProvider.AccertifyTransactionID = transactionId;
            this.saveAccertifyTransactionID(transactionId);

            resolve(transactionId);
            this.events.publish(EVENTS_NAME.ACCERTIFY_ID_UPDATED, transactionId);
          }, (error) => {
            this.clearAccertifyTransactionID();
            LoggerProvider.error(this, LoggerEvent.PluginError, "Accertify: Failed to send device data for transaction ID.", error);
            resolve(null);
          });
        }, (error) => {
          this.clearAccertifyTransactionID();
          LoggerProvider.error(this, LoggerEvent.PluginError, "Accertify: Initialization Failed.", error);
          resolve(null);
        });
      } catch (error) {
        this.clearAccertifyTransactionID();
        LoggerProvider.error(this, LoggerEvent.GeneralException, "Accertify: Transaction Promise exception.", error);
        resolve(null);
      }
    });

    return OrderProvider.AccertifyTransactionPromise;
  }

  async getAccertifyTransactionId() {
    LoggerProvider.info(this, "Accertify: Transaction ID, attempting to retrieve from storage");

    const refreshInterval = 30; // Minutes
    const lastFetchTime = await this.getAccertifyTrxIdFetchTime();
    const accertifyDeviceId = await this.storage.get(StorageType.AccertifyTransactionID);
    const currentTime = new Date().getTime();

    if (!accertifyDeviceId || !lastFetchTime || (currentTime - lastFetchTime) > (refreshInterval * 60 * 1000)) {
      if (!accertifyDeviceId)
        LoggerProvider.info(this, 'Accertify: No existing device ID found');
      else if (!lastFetchTime)
        LoggerProvider.info(this, 'Accertify: No last fetch timestamp found');
      else {
        const minutesElapsed = Math.floor((currentTime - lastFetchTime) / (60 * 1000));
        LoggerProvider.info(this, `Accertify: Existing ID expired (${minutesElapsed} minutes elapsed)`);
      }

      OrderProvider.AccertifyTransactionID = null;
      OrderProvider.AccertifyTransactionPromise = null;

      return null;
    }

    LoggerProvider.info(this, `Accertify: Retrieved Transaction ID from storage: ${accertifyDeviceId}`);
    OrderProvider.AccertifyTransactionID = accertifyDeviceId;

    return accertifyDeviceId;
  }

  private async clearAccertifyTransactionID() {
    OrderProvider.AccertifyTransactionID = null;

    try {
      await this.storage.remove(StorageType.AccertifyTransactionID);
      await this.storage.remove(StorageType.AccertifyTransactionIDFetchedTime);

      LoggerProvider.info(this, "Accertify: Successfully removed previous Transaction ID & Fetched Time from storage.");
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, "Accertify: Failed to remove previous Transaction ID & Fetched Time from storage.");
    }
  }

  private saveAccertifyTransactionID(transactionId: any) {
    Promise.all([
      this.storage.set(StorageType.AccertifyTransactionID, transactionId),
      this.storage.set(StorageType.AccertifyTransactionIDFetchedTime, new Date().getTime().toString())
    ]).then(() => {
      LoggerProvider.info(this, "Accertify: Successfully saved transaction ID & Time to storage");
    }).catch(error => {
      LoggerProvider.error(this, LoggerEvent.GeneralException, "Accertify: Failed to save transaction ID & Time to storage", error);
    });
  }

  private async getAccertifyTrxIdFetchTime() {
    try {
      const lastFetchTimeStr = await this.storage.get(StorageType.AccertifyTransactionIDFetchedTime);

      if (lastFetchTimeStr && lastFetchTimeStr.toString().trim() !== '') {
        const parsedTime = Number(lastFetchTimeStr);
        return !isNaN(parsedTime) ? parsedTime : 0;
      }

      return 0;
    } catch (error) {
      LoggerProvider.exception(this, error, LoggerEvent.GeneralException, "Accertify: Failed to retrieve last Fetch time from storage.");
      return 0;
    }
  }

  private assertCurrencyAllowedOrFail(order: IOrder, callerLabel: string): void {
    if (isCurrencyAllowedForCustomer(order && order.currencyTo)) return;
    LoggerProvider.warning(this, LoggerEvent.GeneralException,
      `Blocked ${callerLabel} for disallowed stablecoin payout currency: ${order && order.currencyTo}`);
    throw new Error('Stablecoin currency not allowed for this customer');
  }

  async validateOrder(order: IOrder, selfServicePspPaymentMethod = null): Promise<IValidateOrderResponse> {
    if (order.pspPaymentMethod === 'scheme' && !order.cardAccount) {
      LoggerProvider.info(this, 'Check for matching card account');
      //this.lastCardAccountsPromise = this.findLastCardAccountInTransactions(order);
    }

    await this.initializeAccertify();
    order.accertifyDeviceId = OrderProvider.AccertifyTransactionID;

    if (!order.accertifyDeviceId)
      LoggerProvider.warning(this, LoggerEvent.AccertifyException, 'Accertify: Failed to get device ID!');

    const validateRequest = OrderMapper.toApiOrderRequestEntity(order, selfServicePspPaymentMethod);

    if (order.paymentMethod === PaymentMethodType.BankAccount && this.isVpaDeliveryMethod(order.deliveryMethodInternal)){
      validateRequest.paymentAccountId = order.bankAccount.accountId;
      validateRequest.bankId = null;
    }
    if (validateRequest.pspPaymentMethod && validateRequest.paymentAccountId) {
      LoggerProvider.info(this, 'Ignore payment account ID ' + validateRequest.paymentAccountId + ' for PSP validate request');
      validateRequest.paymentAccountId = null;
    }
    // Without the bank-deposit arm this nulls the payout bankId the validate mapper just set.
    const isFromSmartRouting = !!(order.deliveryMethodInternal=='MobilePayment' && order.wallet && order.wallet.EntityID)
      || !!order.bankDepositProvider;
    if (validateRequest.pspPaymentMethod && validateRequest.bankId && !isFromSmartRouting) {
      LoggerProvider.info(this, 'Ignore bank ID ' + validateRequest.bankId + ' for PSP validate request');
      validateRequest.bankId = null;
    }

    const paymentMethods = await this.resourceProvider.getPaymentMethods();

    try {
      return await this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}order/validate`, validateRequest, (res: IValidateOrderResponse) => {
        const validate = OrderMapper.fromOrderValidationResponseEntity(res);
        order.transactionId = validate.transactionId;
        order.customerTax = validate.customerTax;

        if (validate.kycRequirementRule !== undefined)
          order.kycRequirementRule = validate.kycRequirementRule;

        if (validate.kycRequirementReasons !== undefined)
          order.kycRequirementReasons = validate.kycRequirementReasons;

        return validate;
      });
    } catch (error) {
      if (error && error.error) {
        const errorData = error.error;

        if (errorData.kycRequirementRule !== undefined)
          order.kycRequirementRule = errorData.kycRequirementRule;

        if (errorData.kycRequirementReasons !== undefined)
          order.kycRequirementReasons = errorData.kycRequirementReasons;

        if (errorData.isEKYCSkipAllowed !== undefined)
          order.isEKYCSkipAllowed = errorData.isEKYCSkipAllowed;

        if (errorData.remainingAmountWithouteKYC !== undefined)
          order.remainingAmountWithouteKYC = errorData.remainingAmountWithouteKYC;
      }

      throw error;
    }
  }

  async createOrder(order: IOrder): Promise<ICreateOrderResponse> {
    this.assertCurrencyAllowedOrFail(order, 'order/create');

    // IMPORTANT:
    // when we start to create an order remove the pending order since if we run into a problem we might not know if the order has been created
    // on the backend (i.e. timeout during order creation) hence if the user logs in again or goes back to activity he could see the continue order CTA
    // which could lead him to create an order twice (remember Juan) !
    // Hence remove the pending order to be on the safe side
    await this.removePendingOrder();


    if (!order.accertifyDeviceId) {
      await this.initializeAccertify();
      order.accertifyDeviceId = OrderProvider.AccertifyTransactionID;
    }

    if (!order.accertifyDeviceId)
      LoggerProvider.warning(this, LoggerEvent.AccertifyException, 'Accertify: Failed to get device ID!');

    const request = OrderMapper.toCreateOrderRequestEntity(order);
    if (request.pspPaymentSessionData)
      request.pspPaymentSessionData.browserInfo = this.utilsProvider.collectBrowserInfo();

    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}order`, request, (res: ICreateOrderResponseEntity) => {
      const created = OrderMapper.fromCreateOrderResponseEntity(res);
      return created;
    });
  }

  async completeOtpCheckOrder(code: string, fraudOtpPreOrderId: number): Promise<ICompleteOtpCheckOrderResponse> {
    const request: ICompleteOtpCheckOrderRequest = {
      Code: code,
      FraudOtpPreOrderId: fraudOtpPreOrderId
    };

    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}order/CompleteOtpCheckOrder`, request, (res: ICompleteOtpCheckOrderResponse) => {
      return res;
    });
  }

  async incompleteOtpCheckOrder(fraudOtpPreOrderId: number): Promise<any> {
    const url = `${APP_CONFIG.remittanceApiBaseUrl}incompleteOtpCheckOrder/cancel`;
    const request = { FraudOtpPreOrderId: fraudOtpPreOrderId };

    return this.httpProvider.post(url, request);
  }

  async completeScamAlertStepUpOrder(preOrderId: number, scamRiskLabel: string, scamRiskCategoryUserSelected?: string): Promise<ICreateOrderResponse> {
    const url = `${APP_CONFIG.remittanceApiBaseUrl}Order/CompleteStepUpOrder`;
    const request: any = {
      Type: 'ScamAlert',
      PreOrderId: preOrderId,
      ScamRiskLabel: scamRiskLabel
    };

    if (scamRiskCategoryUserSelected)
      request.ScamRiskCategoryUserSelected = scamRiskCategoryUserSelected;

    const response: ICreateOrderResponseEntity = await this.httpProvider.post(url, request);
    return OrderMapper.fromCreateOrderResponseEntity(response);
  }

  async cancelScamAlertStepUpOrder(preOrderId: number, scamRiskLabel: string): Promise<any> {
    const url = `${APP_CONFIG.remittanceApiBaseUrl}Order/CancelStepUpOrder`;
    const request = {
      Type: 'ScamAlert',
      PreOrderId: preOrderId,
      ScamRiskLabel: scamRiskLabel
    };

    return this.httpProvider.post(url, request);
  }

  getPoliPay(order: IOrder): Promise<any> {
    let cancelUrl = 'http://localhost:8100/#/payment-poli-cancelled';
    let failedUrl = 'http://localhost:8100/#/payment-poli-failed';
    let successUrl = 'http://localhost:8100/#/payment-poli-finished';
    if (this.platform.is('cordova')) {
      if (this.platform.is('ios')) {
        cancelUrl = 'ionic://localhost/#/payment-poli-cancelled';
        successUrl = 'ionic://localhost/#/payment-poli-finished';
        failedUrl = 'ionic://localhost/#/payment-poli-failed';
      }
      else {
        cancelUrl = 'http://localhost/#/payment-poli-cancelled';
        successUrl = 'http://localhost/#/payment-poli-finished';
        failedUrl = 'http://localhost/#/payment-poli-failed';
      }
    }

    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct`, {
      transactionId: order.transactionId,
      orderNumber: order.orderNumber,
      abortUrl: cancelUrl,
      successUrl: successUrl,
      timeoutUrl: failedUrl,
      updateUrl: failedUrl
    });
  }

  finishPoliPayTransaction(externalTransactionId, result): Promise<any> {
    return this.httpProvider.get(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct/${externalTransactionId}/${result}`);
  }

  async getFpxBanks() {
    const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/payments/directbank/fpx/providersettings`)
    if (result && result.Value && result.Value.Banks && result.Value.Banks.length > 0)
      return result.Value.Banks.map((bank) => {
        return {
          value: bank.Id,
          text: bank.Name,
          isOnline: bank.IsOnline
        }
      })
    throw new Error('Invalid bank providers result')
  }

  async initiateFpxBank(order: IOrder, bankId) {
    const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/payments/directbank/fpx/initiate`, {
      currencyFrom: order.currencyFrom,
      totalAmount: order.totalAmount,
      selectedBankId: bankId,
      transactionId: order.transactionId,
      orderNumber: order.orderNumber,
    })
    if (result && result.Value && result.Value.PostUrl && result.Value.FormFields)
      return {
        postUrl: result.Value.PostUrl,
        fields: result.Value.FormFields.map((field) => {
          return {
            key: field.Key,
            value: field.Value
          }
        })
      }
    throw new Error('Invalid bank initiate result')
  }

  async getFpxTxnStatus(orderNumber) {
    const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/payments/directbank/fpx/status`,{orderNumber: orderNumber});
    if (result && result.Value)
      return result.Value;
    throw new Error('Invalid transaction Status result')
  }


  getKlarna(order: IOrder): Promise<any> {
    let cancelUrl = 'http://localhost:8100/#/payment-klarna-cancelled';
    let failedUrl = 'http://localhost:8100/#/payment-klarna-failed';
    let successUrl = 'http://localhost:8100/#/payment-klarna-finished';
    if (this.platform.is('cordova')) {
      if (this.platform.is('ios')) {
        cancelUrl = 'ionic://localhost/#/payment-klarna-cancelled';
        successUrl = 'ionic://localhost/#/payment-klarna-finished';
        failedUrl = 'ionic://localhost/#/payment-klarna-failed';
      }
      else {
        cancelUrl = 'http://localhost/#/payment-klarna-cancelled';
        successUrl = 'http://localhost/#/payment-klarna-finished';
        failedUrl = 'http://localhost/#/payment-klarna-failed';
      }
    }

    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct`, {
      transactionId: order.transactionId,
      orderNumber: order.orderNumber,
      abortUrl: cancelUrl,
      successUrl: successUrl,
      timeoutUrl: failedUrl,
      updateUrl: failedUrl
    });
  }

  // For iDeal, Bancontact or Giropay
  getFiservTransaction(order: IOrder): Promise<any> {
    let successUrl = `${APP_CONFIG.API_URL}api/payments/directbank/fiserv/apm/authorization-response`;
    let failedUrl = `${APP_CONFIG.API_URL}api/payments/directbank/fiserv/apm/authorization-response`;

    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/payments/directbank/fiserv/apm/initiate`, {
      TransactionId: order.transactionId,
      OrderNumber: order.orderNumber,
      SuccessUrl: successUrl,
      FailUrl: failedUrl
    });
  }

  finishKlarnaTransaction(externalTransactionId, result): Promise<any> {
    return this.httpProvider.get(`${APP_CONFIG.remittanceApiBaseUrl}bank/direct/${externalTransactionId}/${result}`);
  }

  // For iDeal, Bancontact or Giropay
  async verifyFiservTransaction(orderNumber): Promise<any> {
    const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/payments/directbank/fiserv/apm/${orderNumber}/verify-apm-response`, {});
    if (result && result.Value)
      return result.Value;
    throw new Error('Invalid transaction Status result')
  }

  getDirectBankBrand() {
    return this.resourceProvider.getDirectBankBrand();
  }

  async getStagedRiaBrand() {
    if (!APP_CONFIG.featureFlags.kroger) return '';
    try {
      return (APP_CONFIG.region.stagedRiaBrand && APP_CONFIG.region.stagedRiaBrand != '') ? APP_CONFIG.region.stagedRiaBrand:'';
    } catch (ex) {
      LoggerProvider.exception(this,ex,LoggerEvent.ProviderException,"cant get staged ria brand")
    }
  }

  getPayNearMeBrand(force = false) {
    return this.resourceProvider.getPayNearMeBrand(force);
  }

  /**
   * @description Get the publicly-available order information.
   */
  getOrderStatus(orderNumberOrPin: string, getOriginalPayAgent?: boolean, ignoreConnectionError?: boolean, getEta?: boolean, getEventDetails?: boolean): Promise<IOrder> {
    const orderStatusRequest = OrderMapper.toTrackOrderStatusEntity({
      orderNumber: orderNumberOrPin,
      getOriginalPayAgent: getOriginalPayAgent,
      getEta,
      getEventDetails,
    });
    let url = `${APP_CONFIG.API_URL}api/tracking/order/status`;
    if(ignoreConnectionError) {
      url += '?ignore_connection_errors=1';
    }
    return this.httpProvider.post(url, orderStatusRequest, (res: IOrderEntity) => {
      return OrderMapper.fromOrderEntity(res, this.translate);
    });
  }

  /**
   * @description Get Accertify fraud order status
   */
  getAccertifyFraudOrderStatus(orderNo): Promise<any> {
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/tracking/order/characteristics`, {
      ClassId:'300',
      SettingID:'2000',
      OrderNo: orderNo
    });
  }

  /**
   * @description complete the ACHOrder without Early Release
   */
  completeACHOrder(earlyReleaseIntervenedPreOrderId: number): Promise<IOrder> {
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}Order/CompleteACHOrder`, {
      EarlyReleaseIntervenedPreOrderId: earlyReleaseIntervenedPreOrderId
    });
  }

  /**
   * @description cancel the existing ACHOrder
   */
  cancelACHOrder(earlyReleaseIntervenedPreOrderId: number): Promise<IOrder> {
    if (this.customersProvider.transactionsInfo && this.customersProvider.transactionsInfo.transactions) {
      let lastTransactionId = 0;
      if (this.customersProvider.transactionsInfo.filteredTransactions && this.customersProvider.transactionsInfo.filteredTransactions.length > 0)
        lastTransactionId = Math.max(lastTransactionId, this.customersProvider.transactionsInfo.filteredTransactions[0].Id);
      if (this.customersProvider.transactionsInfo.transactions && this.customersProvider.transactionsInfo.transactions.length > 0)
        lastTransactionId = Math.max(lastTransactionId, this.customersProvider.transactionsInfo.transactions[0].Id);
      this.cancelledACHOrders.push(lastTransactionId); // unfortunately we don't have the actual transaction ID but the transaction ID before and hence need to find out the actual transaction ID later
    }
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}incompleteACHOrder/cancel`, {
      EarlyReleaseIntervenedPreOrderId: earlyReleaseIntervenedPreOrderId
    });
  }

  submitCardScanInfo(request: ICardScanRequest): Promise<ICardScanResponse> {
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}order/submitCardScanInfo`, request)
    .then((response: ICardScanResponse) => {
      LoggerProvider.info(this, 'Card scan info submitted successfully', response);
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  cancelOrder(model: ICancelOrderRequest): Promise<ICancelOrderResponse> {
    return this.httpProvider
      .post(`${APP_CONFIG.remittanceApiBaseUrl}order/cancel`, model, (res: ICancelOrderResponseEntity) => {
        return OrderMapper.fromCancelOrderResponseEntity(res);
      });
  }

  cancelOrderStage(orderID: number, cancelReasonId?: number, cancelReasonComment?: string) {
    let customerId = this.httpProvider.getAuthCustomerId();
    let url = `${APP_CONFIG.API_URL}api/Customers/${customerId}/CancelTransaction/${orderID}`;

    const queryParams: string[] = [];

    if (cancelReasonId) {
      queryParams.push(`cancelReasonId=${cancelReasonId}`);
    }
    if (cancelReasonComment) {
      queryParams.push(`cancelReasonComment=${cancelReasonComment}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    return this.httpProvider.delete(url);
  }

  /**
   * @description Get the publicly-available order information.
   */
  getInwardremittanceOrder(orderPin: string): Promise<any> {
    const orderNumber = OrderMapper.toTrackOrderStatusEntity({ orderNumber: orderPin, getOriginalPayAgent: false });
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/wallet/RemittancePayoutToWallet/validate`, orderNumber, (res) => {
      return res;
    });
  }

  getPaymentMethodText(order, translate) {
    let paymentMethodText = "";
    switch(order.paymentMethod) {
        case PaymentMethodType.BankAccount:
          if (order.bankAccount) {
            let bankAccountName = order.bankAccount.name ? order.bankAccount.name : order.bankAccount.bankName;
            paymentMethodText = `${this.trimFunction(this.capitalizeLetters(bankAccountName), 20)} ${this.getMaskAccountNumber(order.bankAccount.maskedAccountNumber)}`;
          }
          break;
        case PaymentMethodType.CreditCard:
          if (order.cardAccount)
            paymentMethodText = `${this.getCardAccountType(order)} ${this.getMaskAccountNumber(order.cardAccount.maskedAccountNumber)}`;
          break;
        case PaymentMethodType.DebitCard:
          if (order.cardAccount)
            paymentMethodText = `${this.getCardAccountType(order)} ${this.getMaskAccountNumber(order.cardAccount.maskedAccountNumber)}`;
          break;
        case PaymentMethodType.EWallet:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.eWallet');
          break;
        case PaymentMethodType.PayNearMe:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.payNearMe');
          break;
        case PaymentMethodType.StagedRia:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.stagedRia');
          break;
        case PaymentMethodType.SencillitoOnline:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.sencillito');
          break;
        case PaymentMethodType.PayID:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.payID');
          break;
        case PaymentMethodType.DirectBank:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.directBank');
          break;
        case PaymentMethodType.RiaWallet:
          paymentMethodText = this.translate.instant('page.paymentAccountDetailsPage.paymentMethods.RiaMobilePayment');
          break;
        case PaymentMethodType.Giropay:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.directBank_Giropay');
          break;
        case PaymentMethodType.StagedOnline:
          paymentMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.payNow');
          break;
        case PaymentMethodType.ApplePay:
          paymentMethodText = "";
          break;
        case PaymentMethodType.GooglePay:
          paymentMethodText = "";
          break;
        case PaymentMethodType.ApplePayCredit:
          paymentMethodText = "";
          break;
        case PaymentMethodType.GooglePayCredit:
          paymentMethodText = "";
          break;
        default:
          paymentMethodText = order.paymentMethod;
      }
    return paymentMethodText;
  }

  getMaskAccountNumber(maskAccountNumber): string {
    if (maskAccountNumber) {
      maskAccountNumber = maskAccountNumber.substring(maskAccountNumber.length - 4);
      maskAccountNumber = `•••• ${maskAccountNumber}`
      return maskAccountNumber;
    }
    return '';
  }

  getMobileWalletAccountMask(order):string  {
    let maskPhoneNumber = "";

  if(order.wallet && order.wallet.accountNo) {
      maskPhoneNumber = order.wallet.accountNo;
      maskPhoneNumber = maskPhoneNumber.substring(maskPhoneNumber.length - 4);
      maskPhoneNumber = ` •••• ${maskPhoneNumber}`
    }
    else {
      maskPhoneNumber = ''
    } 

    return maskPhoneNumber;
  }

  getCardAccountType(order: any): string {
    
    let accountType = "";
    if (order.cardAccount && order.cardAccount.type) {
      accountType = order.cardAccount.type;
    } 
    return accountType;
  }

  changeAgentToId(order, newAgent){
    if(order && newAgent){
      if(newAgent.PayAgentId ){
        if(order.agentToId) order.agentToId = newAgent.PayAgentId;
        if(order.agentTo && order.agentTo.id) order.agentTo.id = newAgent.PayAgentId;
        if(order.agentToLocation && order.agentToLocation.agentId) order.agentToLocation.agentId = newAgent.PayAgentId;
      }
      if(newAgent.PayAgentLocId) order.agentToLocation.locationId = newAgent.PayAgentLocId;
    }
  }

  removeAgentToLocation(order) {
    LoggerProvider.info(this, `Removed agent to location for order ${order.orderNumber} and country ${order.countryTo}`);
    order.agentToLocation = undefined;
  }

  getNewOrderOptions(order: any, useOpenPaymentCountryAgent: boolean): any {
    return {
      OpenPaymentCountry: useOpenPaymentCountryAgent,
      OpenPaymentCorrespondent: order.agentTo ? order.agentTo.isOpenPayment : false,
      LocationSpecific: order.agentTo ? !order.agentTo.isOpenPayment : false,
      LocationDetails: order.agentTo ? order.agentTo.agentLocation : null
    };
  }

  getDeliveryDetails(order: any, orderProvider: any, newOrderOptions: any) {
    return this.getDeliveryMethodText(order, newOrderOptions);
  }

  showDeliveryMethodError(order: IOrder, deliveryMethodNotAvailable: string = null) {
    LoggerProvider.error(this, LoggerEvent.SendMoneyPage, "Delivery method not found error");

    if (this.routeProvider.hasPage(this.routeProvider.pages.SendSummaryPage))
        this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);

    const deliveryMethodText = this.getDeliveryMethodText(order, null);
    const imagePath = 'assets/icon/yellow-warning-icon.svg';  
    const title = this.translate.instant('page.sendSummaryPage.deliveryMethodUnavailableHeader', { deliveryMethod: deliveryMethodText.deliveryMethodText });
    const msg = this.translate.instant('page.sendSummaryPage.deliveryMethodUnavailableContent')
    const primaryButtonText = this.translate.instant("page.sendSummaryPage.updateDeliveryMethodButton");
    const agentLocation = order.agentToLocation ? order.agentToLocation.locationName: "";
    const primaryButtonAction = () => this.goToCalculatorPage(order, deliveryMethodNotAvailable || agentLocation);
   
    this.showGenericErrorModal(imagePath, title, msg, primaryButtonText, primaryButtonAction); 
  }

  showWalletNotAvailableError(order: IOrder, walletName: string) {
    const name = walletName || this.getDeliveryMethodText(order, null).deliveryMethodText;
    const imagePath = 'assets/icon/yellow-warning-icon.svg';
    const title = this.translate.instant('page.sendSummaryPage.deliveryMethodUnavailableHeader', { deliveryMethod: name });
    const msg = this.translate.instant('page.sendSummaryPage.deliveryMethodUnavailableContent');
    const primaryButtonText = this.translate.instant('page.sendSummaryPage.updateDeliveryMethodButton');
    const primaryButtonAction = () => this.goToCalculatorPage(order, order.deliveryMethodInternal as string);

    this.showGenericErrorModal(imagePath, title, msg, primaryButtonText, primaryButtonAction);
  }

  goToCalculatorPage(order: IOrder, deliveryMethodNotAvailable: string = null) {
    if(this.routeProvider.hasPage(this.routeProvider.pages.CheckPricesPage)) {
      this.routeProvider.popTo(this.routeProvider.pages.CheckPricesPage, false, { 'deliveryMethodNotAvailable' : deliveryMethodNotAvailable });
    } else 
    this.routeProvider.setRoot(this.routeProvider.pages.CheckPricesPage, { goToActivity: true, 'deliveryMethodNotAvailable' : deliveryMethodNotAvailable });
  }

  // trackResendFailed: false when the order is not a send again, so a regular send is not reported as a failed resend.
  public showAgentNotFoundError(trackResendFailed = true) {
    if (trackResendFailed)
      this.analytics.trackEvent({
        eventName: AnalyticsEventType.TransferResendFailed, analyticsData: {
          location: location,
          errorType: 'AgentLocationNotAvailable'
        }});

    const imagePath = 'assets/imgs/push-pin-icon.svg';
    const title = this.translate.instant('page.errorMessage.ria_errormessage_agentlocationnotavailableheader');
    const msg = this.translate.instant('page.errorMessage.ria_errormessage_changeagentbody');
    const primaryButtonTitle = this.translate.instant('page.errorMessage.ria_errormessage_updateagentbutton');
    const params = {
      amount: this.order.amountTo,
      country: this.order.countryTo,
      currency: this.order.currencyTo,
      sendAmount: this.order.amountFrom,
      promoRate: this.order.exchangeRatePromo,
      deliveryMethod: this.order.deliveryMethodInternal,
      onSelect: (location, agentLocation) => { 
        this.order.agentTo = location;
        this.order.agentToLocation = agentLocation;
        this.routeProvider.push(this.routeProvider.pages.SendSummaryPage);
      }
    };

    const primaryButtonAction = () => {
      this.routeProvider.replace(this.routeProvider.pages.LocationListPage, params);
    };

    this.showGenericErrorModal(imagePath, title, msg, primaryButtonTitle, primaryButtonAction);
  }

  async checkRecipient(showError = true, orderSendAgain?:IOrder): Promise<IRecipient> {
    if(orderSendAgain)
      this.order = orderSendAgain;
    
    try {
      const recipient = await this.recipientProvider.getRecipient(this.order.recipient.id);

      if (!orderSendAgain) // only update the order if we are not in send again mode, otherwise we overwrite recipient data
        this.order.recipient = { ... this.order.recipient, ...recipient };
      return recipient;
    }
    catch (ex) {
      if (ex.errorCode === ErrorCodeType.RecipientNotFound && showError) {
      LoggerProvider.error(this, LoggerEvent.Popup, 'Recipient of transfer no longer available',ex);
      this.analytics.trackEvent({ eventName: AnalyticsEventType.TransferResendFailed, analyticsData: {
        location: location,
        errorType: 'recipientNotAvailable'
      }});
      // this.recipientNotFoundErrorScreen();
    }
  }

    return null;
  }

  recipientNotFoundErrorScreen() {
    const params = {
      errorTitle: this.translate.instant('page.errorMessage.ria_errormessage_recipientnotavailableheader'),
      errorDetails: this.translate.instant('page.errorMessage.ria_errormessage_recipientnotavailablebody'),
      buttonText: this.translate.instant('global.myRia.jsonContent.CancelTransactionButton'),
      fullButtonClick: () => this.routeProvider.replace(this.routeProvider.pages.CheckPricesPage),
      clickClose: () => this.routeProvider.pop(),
      showBullets: true,
      newDesign: true,
      showFullButton: true,
      isShowHelp: false,
      isShowClose: true
    }

    this.routeProvider.openModal(this.routeProvider.pages.SendFailedPage, params);
  }

  async checkPaymentMethod(orderPromise, showError, header): Promise<boolean> {
    const paymentMethods = await this.resourceProvider.getPaymentMethods();

    const paymentMethodEnable = paymentMethods.filter(payMethod => payMethod.value === this.order.paymentMethod);
    if(paymentMethodEnable.length === 0) {
      const params = {
        params: { repeatTransferFailedError: true }
      };
      this.routeProvider.openModal(this.routeProvider.pages.CheckPricesPage, params);
      return false;
    }

    if (this.order.paymentMethod === PaymentMethodType.BankAccount || this.order.paymentMethod === PaymentMethodType.CreditCard || this.order.paymentMethod === PaymentMethodType.DebitCard) {
      let order = this.order;
      if (orderPromise)
        order = await orderPromise;

      let accountId = null;
      if (order.bankAccount)
        accountId = order.bankAccount.accountId;
      else if (order.cardAccount)
        accountId = order.cardAccount.accountId;

      let accounts: any = [];
      const paymentAccounts = await this.paymentProvider.getPaymentAccounts();
      let isDisabled = false;

      for (let i = 0; i < 2; i++) {
        accounts = paymentAccounts.bankAccounts;
        if (i > 0)
          accounts = paymentAccounts.cards;

        const accountIdMatch = accounts.filter(account => account.accountId === accountId);
        if(accountIdMatch.length > 0) {
          if (accountIdMatch[0].isDisabled || accountIdMatch[0].isExpired) {
            isDisabled = true;
            break;
          }
          return true;
        }
      }

      if (showError) {
        const imagePath = 'assets/icon/yellow-warning-icon.svg';
        const { title, msg, primaryButtonText, primaryButtonAction } = this.getPaymentMethodError(isDisabled, orderPromise, header);

        this.showGenericErrorModal(imagePath, title, msg, primaryButtonText, primaryButtonAction);
      }
      return false;
    }
    return true;
  }

  getPaymentMethodError(isDisabled: boolean, orderPromise, header) {
    const title = this.translate.instant(isDisabled ? "page.paymentAccountDetailsPage.paymentMethodDisabledHeader" : "page.paymentAccountDetailsPage.paymentMethodNotFoundHeader", { paymentMethod: this.getPaymentMethodType(this.order.paymentMethod)});
    const msg = this.translate.instant(isDisabled ? "page.paymentAccountDetailsPage.paymentMethodDisabledContent" : "page.paymentAccountDetailsPage.paymentMethodNotFoundContent");
    const primaryButtonText = this.translate.instant("page.paymentAccountDetailsPage.updatePaymentMethodButton");
    const primaryButtonAction = () => {
      if (isDisabled) {
        this.routeProvider.openModal(this.routeProvider.pages.CheckPricesPage);
      }
      else
        this.onAddingPaymentMethod(orderPromise, header);
    }

    return { title, msg, primaryButtonText, primaryButtonAction };
  }

  onAddingPaymentMethod(orderPromise, header) {
    this.routeProvider.openModal(this.routeProvider.pages.SendAgainPaymentAccountPage, {
      onAdd: () => {
        this.routeProvider.openActionSheetNew(this.routeProvider.pages.PaymentMethodAddSelectPage, {
          schemePaymentEnabled: this.schemePaymentEnabled,
          bankPaymentEnabled: this.bankPaymentEnabled,
          paymentMethod: this.order.paymentMethod,
          onCreated: (account) => {
            this.finishPaymentAccount(orderPromise, header, account);
          }
        });
      },
      onSelect: (account) => {
        this.finishPaymentAccount(orderPromise, header, account);
      },
      paymentMethod: this.order.paymentMethod,
      header: header
    });
  }

  finishPaymentAccount(orderPromise, header, account) {
    if (account) {
      if (account.card)
        this.order.cardAccount = account.card;
      else
        this.order.bankAccount = account.bank;
    }
    this.routeProvider.replace(this.routeProvider.pages.SendAgainPage, { orderPromise: orderPromise, order: this.order, header: header }, this.routeProvider.pages.SendAgainPaymentAccountPage);
  }

  cancelAction(order: Transaction, isStage?: boolean) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant(
        "page.trackReviewDetailsPage.cancelConfirmationModal.cancelConfirmationHeader"
      ),
      message: this.translate.instant(
        "page.trackReviewDetailsPage.cancelConfirmationModal.cancelConfirmationContent"
      ),
      cssClass: 'order-cancel-alert-text',
      buttons: [
        {
          text: this.translate.instant(
            "global.noButton"
          ),
          role: "cancel"
        },
        {
          text: this.translate.instant(
            "page.trackReviewDetailsPage.cancelConfirmationModal.yesButton"
          ),
          handler: () => {
            this.processCancel(order, isStage);
          }
        }
      ]
    });
    confirm.setMode("ios");
    confirm.present();
  }

  async processCancel(order: Transaction, isStage: boolean, reasonString: string = "", reasonId?: number, pendingWalletType?: string, isEarlyCancelling = false, maskedCardNumber?: string) {
    this.loadingProvider.show();
    let result;
    try {
      const payload: ICancelOrderRequest = {
        orderNumber: order.OrderNo,
        cancelReason: reasonString,
        ReasonId: reasonId,
      };

      if (isStage) await this.cancelOrderStage(order.Id, reasonId, reasonString);
      else {result = await this.cancelOrder(payload);}
      // handle cancelation requests once order is paid (i.e. status = false)
      // https://euronet.atlassian.net/browse/RBE-2695
      if(result && result.status!=undefined && result.status===false){
        this.routeProvider.openActionSheetNew(
          this.routeProvider.pages.ModalAlertPage,
          {
            title: this.translate.instant('Page.transferDetails.unableToCancel.title'),
            subtitle: this.translate.instant('Page.transferDetails.unableToCancel.body'),
            swapButtons: true,
            image: 'assets/imgs/post_recipient_edit_big.svg',
            dismissFromSecondary: false,
            primaryButtonText: this.translate.instant('global.gotItButton'),
            showSecondaryButton: false,
          },
        );
      }
      else{
        this.trackPendingTransferCancelled(order, pendingWalletType);
      const cardLastFour = this.utilsProvider.getLastFourDigits(maskedCardNumber);
      const showInstantCopy = isEarlyCancelling && !!cardLastFour;
      let params = {
        showClose: true,
        goToActivity: true,
        hasSecondaryButton: true,
        dismissFromPrimary: false,
        dismissFromSecondary: false,
        img: 'assets/imgs/cancelOrder.svg',
        // Falls back to the existing cancelled copy when the card number is unavailable.
        title: showInstantCopy ? this.translate.instant('page.orderCancelledPage.instantCancelledHeader') : this.translate.instant('global.myRia.jsonContent.CancelTransactionTitle'),
        msg: showInstantCopy
          ? this.translate.instant('page.orderCancelledPage.instantCancelledContent', { cardLastFour })
          : this.translate.instant('global.myRia.jsonContent.CancelTransactionBody'),
        secondaryButtonText: this.translate.instant('page.sendCompletedPage.activityButton'),
        secondaryButtonAction: () => {
          this.homescreenProvider.setHomeScreenLocation('canceled_transaction');
          this.utilsProvider.navigateToHomeOrFallback(this.routeProvider.pages.TabsHomeActivityPage);
        },
        primaryButtonText: this.translate.instant('global.myRia.jsonContent.CancelTransactionButton'),
        primaryButtonAction: () => {
          this.setCurrentOrder(null); // start a new order
          this.routeProvider.setRoot(this.routeProvider.pages.SendPage);
        },
      };
      this.routeProvider.setRoot(this.routeProvider.pages.InfoPage, params);
      }
    } catch (ex) {
      let params= {
        title: this.translate.instant('page.trackReviewDetailsPage.orderCancelFailHeader'),
        subtitle:this.translate.instant('page.trackReviewDetailsPage.orderCancelFailContent'),
        primaryButtonText:this.translate.instant('global.callCustomerServiceButton'),
        secondaryButtonText:this.translate.instant('global.notNowButton'),
        trackEvent: AnalyticsEventType.ContactModalDisplayed,
        openChatWidgetIfAvailable: true,
        trackParams: {
          location: SegmentLocationNames.TransferDetails,
          reason: ContactModalReasons.TransactionCancelationNotAvailable
        },
        primaryAction:() => this.callCustomerService(ContactModalReasons.TransactionCancelationNotAvailable),
        showSecondaryButton :true

      };
      this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, params, null, null, true, true);
    }
    this.loadingProvider.hide();
  }


  private trackPendingTransferCancelled(order: Transaction, pendingWalletType: string) {
    if (!pendingWalletType) return;
    let daysElapsed = 0;
    if (order && order.EnteredTime) {
      const enteredTime = new Date(order.EnteredTime).getTime();
      if (!isNaN(enteredTime)) {
        daysElapsed = Math.floor((Date.now() - enteredTime) / (1000 * 60 * 60 * 24));
      }
    }
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.PendingTransferCancelled,
      analyticsData: {
        pendingTransactionId: order && order.OrderNo ? order.OrderNo : null,
        senderCountry: (order && order.CountryFrom) ? order.CountryFrom : APP_CONFIG.region.defaultCountryFrom,
        destinationCountry: order ? order.CountryTo : null,
        pendingWalletType: pendingWalletType,
        daysElapsed: daysElapsed,
        cancellationSource: PendingTransferCancellationSource.Activity
      }
    });
  }

  callCustomerService(reason = '') {
    this.callProvider.callNumber(this.translate.instant("CustomerServicePhoneNumber"), true, SegmentLocationNames.TransferDetails, reason);
  }

  getAnalyticsPaymentMethod(paymentMethod) {
    let analyticsPaymentObj: any = {};
    analyticsPaymentObj.paymentMethod = this.getAnalyticsPaymentMethodType(paymentMethod);
    const payVendor = this.getAnalyticsPaymentVendor(paymentMethod, analyticsPaymentObj.paymentMethod)

    if (!payVendor && paymentMethod === PaymentMethodType.DirectBank) {
      const directBrand = this.resourceProvider.getDirectBankBrand();
      analyticsPaymentObj.paymentVendor = this.getAnalyticsPaymentVendor(directBrand, AnalyticsPaymentMethodData.DirectBank)
    }

    else if (payVendor) {
      analyticsPaymentObj.paymentVendor = payVendor;
    }

    return analyticsPaymentObj;
  };

  getAnalyticsPaymentMethodType(paymentMethod: string) {
    if (paymentMethod === PaymentMethodType.BankAccount)
      return AnalyticsPaymentMethodData.BankAccount;
    else if (paymentMethod === PaymentMethodType.CreditCard)
      return AnalyticsPaymentMethodData.CreditCard;
    else if (paymentMethod === PaymentMethodType.DebitCard)
      return AnalyticsPaymentMethodData.DebitCard;
    else if (paymentMethod === PaymentMethodType.RiaWallet)
      return AnalyticsPaymentMethodData.Wallet;
    else if (paymentMethod === PaymentMethodType.Cash || paymentMethod === PaymentMethodType.PayNearMe)
      return AnalyticsPaymentMethodData.Staged;
    else if (paymentMethod === PaymentMethodType.StagedRia)
      return AnalyticsPaymentMethodData.Staged;
    else if (paymentMethod === PaymentMethodType.DirectBank)
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === PaymentMethodType.Giropay || paymentMethod === DirectBankBrand.Bancontact || paymentMethod === PaymentMethodType.PayID)
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === DirectBankBrand.PoliPay|| paymentMethod === DirectBankBrand.FPX ||  paymentMethod === DirectBankBrand.IDeal) 
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === DirectBankBrand.Klarna) 
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === DirectBankVendorType.Sofort) 
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === DirectBankBrand.Blik) 
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === DirectBankBrand.MBWay) 
      return AnalyticsPaymentMethodData.DirectBank;
     else if (paymentMethod === DirectBankBrand.Swish) 
      return AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === PaymentMethodType.SencillitoOnline)
      return AnalyticsPaymentMethodData.Staged
    else if (paymentMethod === PaymentMethodType.StagedOnline)
      return AnalyticsPaymentMethodData.StagedOnline
    else if (paymentMethod === PaymentMethodType.ApplePay)
      return AnalyticsPaymentMethodData.ApplePay
    else if (paymentMethod === PaymentMethodType.GooglePay)
      return AnalyticsPaymentMethodData.GooglePay
    else if (paymentMethod === PaymentMethodType.GooglePayCredit)
      return AnalyticsPaymentMethodData.GooglePay
    else if (paymentMethod === PaymentMethodType.ApplePayCredit)
      return AnalyticsPaymentMethodData.ApplePay
    else if (paymentMethod === PaymentMethodType.OpenBanking)
      return AnalyticsPaymentMethodData.OpenBanking
    else if (paymentMethod)
      return paymentMethod.toString();
    return null;
  }

  getAnalyticsCardNetwork(rawBrand: string) {
    if (!rawBrand)
      return null;
    switch (rawBrand.toLowerCase()) {
      case 'visa':
        return 'Visa';
      case 'mc':
      case 'mastercard':
        return 'MasterCard';
      case 'maestro':
        return 'Maestro';
      case 'discover':
        return 'Discover';
      default:
        return rawBrand;
    }
  }

  async updateEtaBadge(order: IOrder, isEarlyReleaseLikely: boolean = false): Promise<IEtaBadge | null> {
    const enabled = (await this.utilsProvider.getFeatureFlagData(FeatureFlagTypes.CalculatorEtaBadgeEnabled)) === true;
    let etaBadge: IEtaBadge | null = null;
    if (!enabled || !order.paymentMethod)
      return etaBadge;

    const key = (suffix: string) => `page.checkPricesPage.${suffix}`;

    if (order.paymentMethod === PaymentMethodType.BankAccount) {
      // OM-20380: the ER Likelihood flag upgrades the ACH badge to the same-day copy
      if (isEarlyReleaseLikely) {
        return { fast: true, prefixKey: key('etaShouldArrivePrefix'), valueKey: key('achEtaEarlyRelease.message'), isAch: true, earlyRelease: true };
      }
      etaBadge = { fast: false, prefixKey: key('achEtaPrefix'), valueKey: key('achEtaDays'), isAch: true };
      return etaBadge;
    }

    // Buckets calibrated against EDW HoursToPaid for US paid orders (2026-08): wallets/UPI ~97% within 5 min,
    // card-funded bank deposits ~90% within 1 hour, home delivery ~99% within 48h.
    switch (order.deliveryMethodInternal) {
      case DeliveryMethodType.MobilePayment:
      case DeliveryMethodType.RiaWallet:
      case DeliveryMethodType.MOBILE_WALLET_NUM_CODE:
      case DeliveryMethodType.UPI:
      case DeliveryMethodType.UPI_NUM_CODE:
        etaBadge = { fast: true, prefixKey: key('achEtaPrefix'), valueKey: key('etaWalletValue'), isAch: false };
        break;
      case DeliveryMethodType.PIX:
      case DeliveryMethodType.Alipay:
      case DeliveryMethodType.PIX_NUM_CODE:
      case DeliveryMethodType.Alipay_NUM_CODE:
      case DeliveryMethodType.OfficePickup:
      case DeliveryMethodType.CashPickup:
      case DeliveryMethodType.CASH_PICKUP_NUM_CODE:
      case DeliveryMethodType.BankDeposit:
      case DeliveryMethodType.DebitCard:
      case DeliveryMethodType.AtmPickup:
      case DeliveryMethodType.BANK_DEPOSIT_NUM_CODE:
      case DeliveryMethodType.DEBIT_CARD_NUM_CODE:
      case DeliveryMethodType.ATM_PICKUP_NUM_CODE:
        etaBadge = { fast: true, prefixKey: key('achEtaPrefix'), valueKey: key('etaHourValue'), isAch: false };
        break;
      case DeliveryMethodType.BankDepositNextDay:
      case DeliveryMethodType.HomeDelivery:
      case DeliveryMethodType.BANK_DEPOSIT_NEXT_DAY_NUM_CODE:
      case DeliveryMethodType.HOME_DELIVERY_NUM_CODE:
        etaBadge = { fast: false, prefixKey: key('etaShouldArrivePrefix'), valueKey: key('etaTomorrowValue'), isAch: false };
        break;
    }

    return etaBadge;
  }

  getAnalyticsPaymentVendor(paymentMethod: any, analyticsPaymentMethod: any) {
    if(analyticsPaymentMethod === AnalyticsPaymentMethodData.Staged || analyticsPaymentMethod === AnalyticsPaymentMethodData.DirectBank || analyticsPaymentMethod === AnalyticsPaymentMethodData.OpenBanking) {
      switch(paymentMethod) {
        case PaymentMethodType.SencillitoOnline:
          return StagedVendorType.Sencillito;
        case PaymentMethodType.StagedRia:
          return StagedVendorType.StagedRia;
        case PaymentMethodType.Cash:
          return StagedVendorType.StagedRia;
        case PaymentMethodType.PayNearMe:
          return StagedVendorType.PayNearMe;
        case PaymentMethodType.Giropay:
          return DirectBankVendorType.GiroPay;
        case PaymentMethodType.PayID:
          return DirectBankVendorType.PayID
        case PaymentMethodType.StagedOnline:
          return StagedVendorType.StagedOnline;

        case DirectBankBrand.PoliPay:
          return DirectBankVendorType.Poli
        case DirectBankBrand.FPX:
          return DirectBankVendorType.FPX
        case DirectBankBrand.IDeal:
          return DirectBankVendorType.IDeal
        case DirectBankVendorType.Sofort:
          return DirectBankVendorType.Sofort
        case DirectBankBrand.Bancontact:
          return DirectBankVendorType.Bancontact;
        case DirectBankBrand.Klarna:
          return DirectBankVendorType.Klarna;
        case DirectBankBrand.Blik:
          return DirectBankVendorType.Blik;
        case DirectBankBrand.Swish:
          return DirectBankVendorType.Swish;
        case DirectBankBrand.MBWay:
          return DirectBankVendorType.MBWay;
        case PaymentMethodTypeID.PayNearMe:
          return StagedVendorType.PayNearMe;
        case PaymentMethodTypeID.PayID:
          return DirectBankVendorType.PayID;
        case PaymentMethodTypeID.Cash:
          return StagedVendorType.StagedRia;
        case PaymentMethodType.DirectBank:
          {
            if (APP_CONFIG.region.region === Region.CL)
              return DirectBankVendorType.Fintoc;
            else
              return '';
          }
        case PaymentMethodType.OpenBanking:
          return OpenBankingBrand.TrueLayer;
      }
    }
  }

  getAnalyticsDeliveryMethodType(deliveryMethod: DeliveryMethodType) {
    if (deliveryMethod === DeliveryMethodType.OfficePickup)
      return AnalyticsPayoutMethodType.OfficePickup;
    else if (deliveryMethod === DeliveryMethodType.BankDeposit)
      return AnalyticsPaymentMethodData.BankAccount;
    else if (deliveryMethod === DeliveryMethodType.HomeDelivery)
      return AnalyticsPayoutMethodType.HomeDelivery;
    else if (deliveryMethod === DeliveryMethodType.MobilePayment)
      return AnalyticsPaymentMethodData.Wallet;
    else if (deliveryMethod && deliveryMethod !== DeliveryMethodType.Any)
      return deliveryMethod.toString();
    return null;
  }

  async getPayoutAgentType(order: IOrder) {
    if (order.deliveryMethodInternal === DeliveryMethodType.OfficePickup) {
      const destinationCountry = await this.resourceProvider.getCountryByValue(order.countryTo);

      if (order.agentTo && order.agentTo.isOpenPayment)
        return PayoutAgentType.Open;

      if (order.agentTo && !order.agentTo.isOpenPayment)
        return PayoutAgentType.Specific;

      if (destinationCountry.isOpenPaymentCountry)
        return PayoutAgentType.OpenPaymentCountry;

      if (order.agentTo && order.agentTo.digitalCorrespondentGroups)
        return PayoutAgentType.PreferredNetwork;

      return PayoutAgentType.OfficePickup;
    }

    if (order.deliveryMethodInternal === DeliveryMethodType.BankDeposit)
      return PayoutAgentType.Bank;
    
    if (this.isVpaDeliveryMethod(order.deliveryMethodInternal) || order.deliveryMethodInternal === DeliveryMethodType.PagoMovil)
      return PayoutAgentType.VPA;

    if (order.deliveryMethodInternal === DeliveryMethodType.MobilePayment)
      return PayoutAgentType.Wallet;

    if(order.deliveryMethodInternal === DeliveryMethodType.HomeDelivery )
      return PayoutAgentType.Specific;

    return null;
  }

  getVopAnalyticsContext(order: IOrder, location: string) {
    const data = order ? this.getAnalyticsDataFromOrder(order) : {} as any;
    return {
      location,
      paymentMethod: data.paymentMethod,
      countryFrom: data.senderCountry,
      destinationCountry: data.destinationCountry,
      payoutMethod: data.payoutMethod,
    };
  }

  getAnalyticsDataFromOrder(order: IOrder, extended = false, isFirstOrder = false) {
    let payment = this.getAnalyticsPaymentMethodType(order.paymentMethod);
    let paymentVendor = this.getAnalyticsPaymentVendor(order.paymentMethod, payment);

    if(!paymentVendor && payment === AnalyticsPaymentMethodData.DirectBank) {
      const directBrand = this.resourceProvider.getDirectBankBrand();
      paymentVendor = this.getAnalyticsPaymentVendor(directBrand, payment)
    }

    let payout = this.getAnalyticsDeliveryMethodType(order.deliveryMethodInternal);

    let data: any = {
      senderCountry: (order.countryFrom) ? order.countryFrom : APP_CONFIG.region.defaultCountryFrom,
      destinationCountry: order.countryTo,
      sendCurrency: order.currencyFrom,
      sendAmount: SegmentProvider.formatNumber(order.amountFrom),
      paymentMethod: payment,
      payoutCurrency: order.currencyTo,
      payoutAmount: SegmentProvider.formatNumber(order.amountTo),
      payoutMethod: order.deliveryMethodAlias === DeliveryMethodType.RiaWallet ? AnalyticsPayoutMethodType.RiaWallet : payout,
      promoId: order.promoId? order.promoId : null,
      promoName: order.promoTitle? order.promoTitle : null,
      paymentType: order.paymentMethod,
      rate: order.exchangeRate,
      customerId: order.customerId ? order.customerId : 0,
      orderNumber: order.orderNumber ? order.orderNumber : 0
    }

    if(paymentVendor) {
      data = {...data, paymentVendor: paymentVendor};
    }

    if (extended) {
      let payoutAgentName: any = this.getPayoutAgentName(order);

      data = {
        ...data,
        destinationCity: (order.recipient) ? order.recipient.city : '',
        payoutAgentName,
        promoNameToLower: (order.promoTitle) ? order.promoTitle.toLowerCase() : '',
        rate: order.exchangeRate,
        recipientFirstName: (order.recipient) ? order.recipient.firstName : '',
        recipientLastName: (order.recipient) ? order.recipient.lastName1 : '',
        totalAmountPaid: order.totalAmount,
        orderNumber: order.orderNumber,
        referralCode: order.IsReferralPromo ? order.promoName : null,
        promoType: order.IsReferralPromo ? 'RAF' : null,
        newCustomerReferral: order.IsReferralPromo,
        referralProgram: order.IsReferralPromo ? 'RAF' : null,
        ...(order.countEnteredOrders && { countEnteredOrders: order.countEnteredOrders })
      };
    } else {
      data = {
        ...data,
        sendAmountUSD: order.sendAmountUSD // TODO
      }
    }

    if(isFirstOrder) {
      data = {
        ...data,
        legitimateInterestOnly: false
      }
    }

    return data;
  }

  getPayoutAgentName(order: IOrder): any {
    if (order.deliveryMethodInternal === DeliveryMethodType.BankDeposit && order.recipient)
      return order.recipient.bankName;
    else if (order.deliveryMethodInternal === DeliveryMethodType.MobilePayment && order.wallet && order.wallet.EntityName)
      return order.wallet.EntityName;
    else if (order.deliveryMethodInternal === DeliveryMethodType.MobilePayment && order.wallet && order.wallet.Name)
      return order.wallet.Name;
    else if (order.deliveryMethodInternal === DeliveryMethodType.UPI)
      return order.bankName;
    else if (order.deliveryMethodInternal === DeliveryMethodType.Alipay)
      return DeliveryMethodType.Alipay;
    else if (order.deliveryMethodInternal === DeliveryMethodType.PIX)
      return DeliveryMethodType.PIX;
    else if (order.deliveryMethodInternal === DeliveryMethodType.BreB)
      return DELIVERY_METHOD.BREB.Text;
    // The paying correspondent is only resolved by the backend at order creation, so the client reports the method itself
    else if (order.deliveryMethodInternal === DeliveryMethodType.PagoMovil)
      return DeliveryMethodType.PagoMovil;
    else if (order.agentToLocation)
      return order.agentToLocation.agentName;
    else if (order.agentTo)
      return order.agentTo.name;

    return null;
  }

  getPayoutAgentId(order: IOrder) {
    if (order.agentToLocation)
      return order.agentToLocation.agentId;
    else if (order.agentTo)
      return order.agentTo.id;

    return null;
  }

  getAnalyticsPaymentMethodTypeById(paymentMethod: PaymentMethodTypeID) {
    let payment = paymentMethod.toString();
    let paymentAgent = "";
    if (paymentMethod === PaymentMethodTypeID.BankAccount)
      payment = AnalyticsPaymentMethodData.BankAccount;
    else if (paymentMethod === PaymentMethodTypeID.DirectBank)
      payment = AnalyticsPaymentMethodData.DirectBank;
    else if (paymentMethod === PaymentMethodTypeID.RiaWallet)
      payment = AnalyticsPaymentMethodData.Wallet;
    else if (paymentMethod === PaymentMethodTypeID.StagedOnline)
      payment = AnalyticsPaymentMethodData.StagedOnline;
    else if (paymentMethod === PaymentMethodTypeID.CreditCard)
      payment = AnalyticsPaymentMethodData.CreditCard;
    else if (paymentMethod === PaymentMethodTypeID.DebitCard)
      payment = AnalyticsPaymentMethodData.DebitCard;
    else if (paymentMethod === PaymentMethodTypeID.Cash || paymentMethod === PaymentMethodTypeID.PayNearMe) {
      payment = AnalyticsPaymentMethodData.Staged;
      paymentAgent = 'seven_eleven';
    }
    else if (paymentMethod === PaymentMethodTypeID.StagedRia) {
      payment = AnalyticsPaymentMethodData.Staged;
      paymentAgent = 'ria_store'; // TODO confirm ?
    }

    return {payment, paymentAgent};
  }

  getAnalyticsDataFromTransaction(transaction: Transaction, order?: IOrder) {
    // let payment = transaction.PaymentMethod.toString();
    // let paymentAgent = '';
    let {payment, paymentAgent} = this.getAnalyticsPaymentMethodTypeById(transaction.PaymentMethod);
    let paymentVendor = this.getAnalyticsPaymentVendor(transaction.PaymentMethod, payment);
    if(order) {
      payment = this.getAnalyticsPaymentMethodType(order.paymentMethod);
      paymentVendor = this.getAnalyticsPaymentVendor(order.paymentMethod, payment);
    }

    if(!paymentVendor && (payment === PaymentMethodType.DirectBank || payment === AnalyticsPaymentMethodData.DirectBank)) {
      const directBrand = this.getDirectBankBrand();
      paymentVendor = this.getAnalyticsPaymentVendor(directBrand, payment)
    }
    let payout = transaction.DelivMethod.toString();
    if (transaction.DelivMethod === DELIVERY_METHOD.CASH_PICKUP.Id)
      payout = AnalyticsPayoutMethodType.OfficePickup;
    else if (transaction.DelivMethod === DELIVERY_METHOD.BANK_DEPOSIT.Id)
      payout = AnalyticsPayoutMethodType.BankAccount;
    else if (transaction.DelivMethod === DELIVERY_METHOD.HOME_DELIVERY.Id)
      payout = AnalyticsPayoutMethodType.HomeDelivery;

    let data: any = {
      transactionId: transaction.OrderNo,
      senderCountry: transaction.CountryFrom,
      destinationCountry: transaction.CountryTo,
      sendCurrency: transaction.PaymentCurrency,
      sendAmount: SegmentProvider.formatNumber(transaction.AmountLocal),
      paymentMethod: payment,
      payoutCurrency: transaction.Currency,
      payoutAmount: SegmentProvider.formatNumber(transaction.TransferAmount),
      payoutMethod: payout,
      promoId: null, // TODO ?
      promoName: null, // TODO ?
      paymentAgent: paymentAgent, // TODO ?
      payoutAgentId: SegmentProvider.formatInt(transaction.PayAgentId),
      payoutLocationId: SegmentProvider.formatInt(transaction.PayAgentLocId),
      //payoutAgentType: open, specific // TODO ?
    }

    if(paymentVendor) {
      data = {...data, paymentVendor: paymentVendor};
    }

    return data;
  }

  isPayingWithCashStagedUS(transaction: Transaction) {
    if(transaction) {
      if(APP_CONFIG.featureFlags.kroger && APP_CONFIG.region === regions.US && (transaction.PaymentMethod === PaymentMethodTypeID.StagedRia || transaction.PaymentMethod === PaymentMethodTypeID.PayNearMe)) {
        return true
      }
    }
    return false
  }

  /**
   * 
   * @param order
   * @returns isStaged
   * this function to be name meaningful to get if the order is Staged or not
   */
  isStagedOrder(order: IOrder): boolean {
    return this.isStagedPaymentMethod(order.paymentMethod) ;
  }
  /**
   * 
   * @param paymentMethod 
   * @returns isStagedPayment
   * this function because on selecting the payment method need to check if it staged or not
   */
  isStagedPaymentMethod(paymentMethod): boolean {
    return (paymentMethod === PaymentMethodType.StagedRia
      || paymentMethod === PaymentMethodType.SencillitoOnline
      || paymentMethod === PaymentMethodType.PayID
      || paymentMethod === PaymentMethodType.RiaWallet
      || paymentMethod === PaymentMethodType.StagedOnline
    );
  }

  isBankDepositDeliveryMethod(deliveryMethod): boolean {
    return (deliveryMethod === DeliveryMethodType.BankDeposit ||
      deliveryMethod === DeliveryMethodType.Alipay ||
      deliveryMethod === DeliveryMethodType.PIX ||
      deliveryMethod === DeliveryMethodType.UPI ||
      deliveryMethod === DeliveryMethodType.BreB ||
      deliveryMethod === DeliveryMethodType.PagoMovil ||
      deliveryMethod === DeliveryMethodType.DebitCard)
  }

  isVpaDeliveryMethod(deliveryMethod): boolean{
    return (deliveryMethod === DeliveryMethodType.Alipay ||
      deliveryMethod === DeliveryMethodType.PIX ||
      deliveryMethod === DeliveryMethodType.UPI ||
      deliveryMethod === DeliveryMethodType.BreB)
  }

  isStagedPaymentMethodById(paymentMethod): boolean {
    return (paymentMethod === PaymentMethodTypeID.StagedRia
      || paymentMethod === PaymentMethodTypeID.SencillitoOnline
      || paymentMethod === PaymentMethodTypeID.PayID
      || paymentMethod === PaymentMethodTypeID.RiaWallet
      || paymentMethod === PaymentMethodType.StagedOnline);
  }


  isFirstTimeStagedTransaction() {
    if(this.customersProvider.transactionsv2) {
        const transactions = this.customersProvider.transactionsv2;
        const result =  transactions.some((transaction) => {
          if(this.isStagedPaymentMethodById(transaction.PaymentMethod)) {
            return true;
          }
        });
        return !result;
    }
    else {
      return true;
    }
  }


  async checkTxnStatus() {
    if (this.txnStatusPromise) {
      await this.txnStatusPromise;
      return;
    }
    return this.txnStatusPromise = new Promise(async (resolve, reject) => {
      return this.checkTxnStatusPromise(resolve, reject);
    });
  }

  private async checkTxnStatusPromise(resolve, reject) {
    try {
      this.loadingProvider.show();
      const value = await this.verifyFiservTransaction(this.order.orderNumber);
      if (value && value.ExternalTransactionId == null && value.Result == null)
        throw false;
      switch (value.Result) {
        case 1: // Success
          this.routeProvider.push(this.routeProvider.pages.SendCompletedPage, { reviewPrompt: false });
          break;
        case 2: // Fail
          if (await this.getDirectBankBrand() === DirectBankBrand.Bancontact)
            this.routeProvider.push(this.routeProvider.pages.SendPayBancontactFailedPage);
          else if (this.order.paymentMethod === PaymentMethodType.Giropay)
            this.routeProvider.push(this.routeProvider.pages.SendPayGiropayFailedPage);
          else
            this.routeProvider.push(this.routeProvider.pages.SendPayIDealFailed);
          break;
        case 60: // Waiting
          let params = {
            img: 'assets/imgs/stopwatch.svg',
            title: this.translate.instant('page.transferInProgress.title'),
            msg: this.translate.instant('page.transferInProgress.description'),
            primaryButtonText: this.translate.instant('page.sendCompletedPage.activityButton'),
            primaryButtonAction: () => {
              this.utilsProvider.navigateToHomeOrFallback(this.routeProvider.pages.TabsHomeActivityPage);
            }
          };
          this.logDirectBankTransactionEvent("pending");
          this.routeProvider.push(this.routeProvider.pages.InfoPage, params);
          break;
        case 3: // Cancel
          break;
      }
      this.loadingProvider.hide();
      resolve(true);
      this.txnStatusPromise = null;
    } catch (ex) {
      this.loadingProvider.hide();
      this.checkStatCounter++;
      if (this.checkStatCounter > 2) {
        this.checkStatCounter = 0;
        reject();
      } else {
        setTimeout(() => this.checkTxnStatusPromise(resolve, reject), 2000);
      }
    }
  }

  trimFunction = (str: string, strLen: number): string => {
    var trimmedString =
      str.length > strLen ? str.substring(0, strLen - 3) + "..." : str;
    return trimmedString;
  };
  
  capitalizeLetters = (text: string) => {
    if (!text)
      return '';
    text = text.toLocaleLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  
  getPagoMovilAccountNumber(recipient: any, fallbackAccountNo: string = ''): string {
    const prefix = (recipient && recipient.virtualPaymentAccountNoPrefix) || '';
    let accountNumber = ((recipient && recipient.virtualPaymentAccountNo) || fallbackAccountNo || '').replace(/\*/g, '');
    if (prefix && accountNumber.length === 7)
      accountNumber = FormFieldMergeTransformer.combineForDisplay(prefix, accountNumber);

    if (accountNumber.length !== 11)
      return accountNumber;

    return this.utilsProvider.formatValueWithPattern(accountNumber, AccountFormatPatterns.PagoMovilPhone);
  }

  getDeliveryMethodText(order: IOrder, newOrder: any = {}): any {
    let deliveryMethodText = order.deliveryMethod;
    let showLocationBtn = false;
    let hasLocationCoords = false;    
    let deliveryMethodSecondaryText = "";
    if(order.deliveryMethodInternal === DeliveryMethodType.BankDeposit && order.recipient) {
      if(order.isPagoMovil) {
        // The API returns Pago Movil orders as BankDeposit, so this branch renders them too.
        deliveryMethodText = DELIVERY_METHOD.PAGO_MOVIL.Text;
        deliveryMethodSecondaryText = this.getPagoMovilAccountNumber(order.recipient, order.virtualPaymentAccountNo);
      } else {
      let bankAccountNumber = order.recipient.bankAccountNumber;
      if (!bankAccountNumber)
        bankAccountNumber = order.recipient.bankAccountNumberUnitary ? order.recipient.bankAccountNumberUnitary : order.recipient.virtualPaymentAccountNo ? order.recipient.virtualPaymentAccountNo : null ;
        deliveryMethodText = order.deliveryMethod;
        deliveryMethodSecondaryText = `${this.trimFunction(this.capitalizeLetters(order.recipient.bankName), 20)} ${this.getMaskAccountNumber(bankAccountNumber)}`
      }
    } else if(order.deliveryMethodInternal === DeliveryMethodType.OfficePickup) {
      if(order.cashPayoutType){
        switch (order.cashPayoutType) {
          case CashPayoutType.OpenPaymentCountry:
            deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyPickupLocation');
            showLocationBtn = true;
            break;
          case CashPayoutType.OpenPaymentCorrespondent:
            const locationAtText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyLocationAt');
            deliveryMethodText = locationAtText;
            deliveryMethodSecondaryText = order.agentTo ? this.getAgentName(order.agentTo) : '';
            break;
          case CashPayoutType.LocationSpecific:
            deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_pickupSpecificLocation');
            showLocationBtn = true;
            break;
          default:
            deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyPickupLocation');
            showLocationBtn = true;
        }
      } 
      if(!order.cashPayoutType){
        if(newOrder && newOrder.OpenPaymentCountry){
          deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyPickupLocation');
          showLocationBtn = true;
        }
        else if(newOrder && newOrder.OpenPaymentCorrespondent && order.agentTo) {
          const locationAtText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyLocationAt');
          deliveryMethodText = locationAtText;
          deliveryMethodSecondaryText = order.agentTo ? this.getAgentName(order.agentTo) : '';

          if(order.agentTo.locationCount  == 1)
            showLocationBtn = true;          
        }
        else if(newOrder && !newOrder.OpenPaymentCorrespondent && newOrder.LocationSpecific) {
          deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_pickupSpecificLocation');
          showLocationBtn = true;
        }
        else{
          deliveryMethodText = this.translate.instant('page.sendSummaryPage.detailsDelivery_anyPickupLocation');
          showLocationBtn = true;
        }

      }
    } 
    else if(order.deliveryMethodInternal === DeliveryMethodType.MobilePayment) {
      deliveryMethodText = this.translate.instant('page.sendReceiptPage.paymentMethods.eWallet');
      if (order.agentToLocation && order.agentToLocation.locationName) // try to use the real wallet consumer brand and not correspondent or intermediary
        deliveryMethodSecondaryText = order.agentToLocation.locationName
      else
        deliveryMethodSecondaryText = (order.agentTo && order.agentTo.name) ? order.agentTo.name : order.deliveryMethod;

      deliveryMethodSecondaryText = deliveryMethodSecondaryText + `${this.getMobileWalletAccountMask(order)}`;
    }
    else if(order.deliveryMethodInternal === DeliveryMethodType.PagoMovil) {
      deliveryMethodText = DELIVERY_METHOD.PAGO_MOVIL.Text;
      deliveryMethodSecondaryText = this.getPagoMovilAccountNumber(order.recipient, order.virtualPaymentAccountNo);
    }

    else if(order.deliveryMethodInternal === DeliveryMethodType.HomeDelivery) {
      if (order.agentToLocation && order.agentToLocation.locationName){
        deliveryMethodText = order.deliveryMethod;
        showLocationBtn = true;
      }
      else {
        deliveryMethodText = order.deliveryMethod;
      }
        
    }
    else if (order.deliveryMethodInternal === DeliveryMethodType.BreB) {
      deliveryMethodText = DELIVERY_METHOD.BREB.Text;
    }
     
    if(InstantDeliveryTypes.indexOf(order.deliveryMethodInternal) > -1) {
      let vpaAccountNo = order.virtualPaymentAccountNo;
      if (order.recipient && order.recipient.virtualPaymentAccountNo)
        vpaAccountNo = order.recipient.virtualPaymentAccountNo;
      deliveryMethodSecondaryText = vpaAccountNo;
      if(order.deliveryMethodInternal === DeliveryMethodType.PIX && vpaAccountNo !== null)
        deliveryMethodSecondaryText = this.utilsProvider.formatValueWithPattern(vpaAccountNo, AccountFormatPatterns.CPFNumber);
    } else if (order.deliveryMethodInternal === DeliveryMethodType.DebitCard && order.recipientDebitCard) {
      deliveryMethodText = this.translate.instant('form.visaDirect.deliveryMethodName');
      deliveryMethodSecondaryText = '••••' + order.recipientDebitCard.bankAccountNumber.replaceAll('*', '').substr(-4);
      deliveryMethodSecondaryText = order.recipientDebitCard.cardIssuerName + ' ' + order.recipientDebitCard.cardNetworkName + ' ' + deliveryMethodSecondaryText;
    }

    return { deliveryMethodText, showLocationBtn, hasLocationCoords, deliveryMethodSecondaryText };
  }
  
  checkPromoAmount(order: IOrder) {
    const promoObject: IPromotionObject = {
      isPromoBonus: false,
      isPromoDiscount: false,
      isSendingAmountDiscount: false,
      promoBonusAmount: 0,
      promoDiscountAmount: 0,
      isPromoTypeReferral:false
    };

    const promoInfoResp = order.promoInfoResponse;
    if(promoInfoResp) {
      promoObject.isPromoDiscount =
        promoInfoResp.isPromoApplied &&
        promoInfoResp.isFeeDiscounted &&
        promoInfoResp.discountAmount > 0;

      promoObject.isPromoBonus =
        promoInfoResp.isPromoApplied &&
        promoInfoResp.isBonusAdded &&
        promoInfoResp.bonusAmount > 0;

      promoObject.isSendingAmountDiscount =
        promoInfoResp.isPromoApplied &&
        !promoInfoResp.isFeeDiscounted &&
        promoInfoResp.discountAmount > 0;

      if (promoObject.isPromoDiscount) {
        promoObject.promoDiscountAmount = promoInfoResp.discountAmount;
      } else if (promoObject.isPromoBonus) {
        promoObject.promoBonusAmount = promoInfoResp.bonusAmount;
      }
      if(promoInfoResp.bonusAmount < 0){
        promoObject.isPromoTypeReferral = true;
        promoObject.promoBonusAmount = promoInfoResp.bonusAmount;
      }
    }

    return promoObject;
  }

  canUseCSTCancelEPForThisPaymentMethod(paymentMethod): boolean {
    return (paymentMethod === PaymentMethodType.StagedRia
      || paymentMethod === PaymentMethodType.RiaWallet);
  }

  async requireLocationSelection(order) {
    const country = await this.resourceProvider.getCountryByValue(order.countryTo);
    if (order.deliveryMethodInternal === DeliveryMethodType.OfficePickup && !country.isOpenPaymentCountry)
      return true;
    else if (order.deliveryMethodInternal === DeliveryMethodType.HomeDelivery)
      return true;
    return false;
  }

  isPspPayment(order) {
    if (this.resourceProvider.getPspPaymentMethod(order.paymentMethod))
      return true;
    return false;
  }

  requirePaymentSelection(order) {
    if (order.paymentMethod === PaymentMethodType.PayNearMe || order.paymentMethod === PaymentMethodType.DirectBank || order.paymentMethod === PaymentMethodType.Giropay ||
        this.isStagedOrder(order) || this.isPspPayment(order))
      return false;
    
    return true;
  }

  async checkValidOrder() {
    this.validOrder = false;
    this.validPayment = false;
    this.validDelivery = false;
    this.validRecipient = false;

    if (!this.order)    
      return;

    this.validOrder = true;
    if (this.order.recipient && this.order.recipient.id)
      this.validRecipient = true;

    if (this.validRecipient && this.order.recipient) {
      if (this.order.deliveryMethodInternal === DeliveryMethodType.OfficePickup || this.order.deliveryMethodInternal === DeliveryMethodType.HomeDelivery) {
        const requireLocation = await this.requireLocationSelection(this.order);
        if (!requireLocation)
          this.validDelivery = true;
        else if (this.order.agentTo != null && this.order.selectedDelivery)
          this.validDelivery = true;
      } else if (this.order.selectedDelivery) {      
        if (this.order.deliveryMethodInternal === DeliveryMethodType.BankDeposit && this.order.recipient.bankName)
          this.validDelivery = true;
        else if (this.order.deliveryMethodInternal === DeliveryMethodType.MobilePayment && this.order.recipient.mobileWalletAccountNo)
          this.validDelivery = true;
        else if (this.isVpaDeliveryMethod(this.order.deliveryMethodInternal) && this.order.recipient.virtualPaymentType)
          this.validDelivery = true;
        else if (this.order.deliveryMethodInternal === DeliveryMethodType.DebitCard && this.order.recipientDebitCard)
          this.validDelivery = true;
      }
    }
    /*
    if (this.order.deliveryMethodInternal === DeliveryMethodType.OfficePickup && this.isOpenPaymentCountry)
      this.editableDelivery = false;
    */

    if (this.order.paymentMethod === PaymentMethodType.BankAccount && this.order.bankAccount && this.order.bankAccount.accountId)
      this.validPayment = true;
    else if ((this.order.paymentMethod === PaymentMethodType.DebitCard || this.order.paymentMethod === PaymentMethodType.CreditCard) && 
        this.order.cardAccount && this.order.cardAccount.accountId)
      this.validPayment = true;
    else if (!this.requirePaymentSelection(this.order)) {
      this.validPayment = true;
    }

    if (!this.validPayment || !this.validRecipient || !this.validDelivery)
      this.validOrder = false;
  }

  showUnsavedChangesWarning(viewCtrl?: ViewController) {
    this.routeProvider.openActionSheetNew(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant('page.continueTransferPage.closeTransferHeader'),
        subtitle: this.translate.instant('page.continueTransferPage.closeTransferBody'),
        swapButtons: true,
        image: 'assets/icons/warning_new.svg',
        primaryButtonText: this.translate.instant('global.resumeButton'),
        primaryAction: () => {
        },
        secondaryButtonText: this.translate.instant('page.priceCalculatorPage.goBackButton'),
        secondaryAction: async () => {
            await this.routeProvider.waitForTransitions();
            
            if(viewCtrl)
              viewCtrl.dismiss();
            
            this.routeProvider.popTo(this.routeProvider.pages.TabsHomeActivityPage);
        },
        dismissFromSecondary: false,
        showSecondaryButton : true
      },
    );
  }

  async logDirectBankTransactionEvent(status: String) {
    if(this.order.paymentMethod !== PaymentMethodType.Giropay && this.order.paymentMethod !== PaymentMethodType.DirectBank)
      return;

    const directBank = this.getDirectBankBrand();
    
    if(directBank in DirectBankVendorType) {
      const location =  this.routeProvider.hasPage(this.routeProvider.pages.CheckPricesPage) ? SegmentLocationNames.SendMoney: SegmentLocationNames.SendAgain;
      const isFirstOrder = (this.order.countEnteredOrders && this.order.countEnteredOrders === 1)
      this.analytics.trackEvent({ eventName: AnalyticsEventType.TransactionCreated, analyticsData: {
        status: status,
        earlyReleased: false,
        transferFlowType: location ==  SegmentLocationNames.SendAgain? "Resend": "From Scratch",
        promoRate: this.order.exchangeRatePromo ? this.order.exchangeRatePromo : null,
        ...this.getAnalyticsDataFromOrder(this.order, true, isFirstOrder),
        ...getSourceAnalyticsData(),
        ...getCampaignAnalyticsData() }});
    }
  }

  async setPaynowRoute(transaction, isShowExpiresAlert: boolean = false){
    this.loadingProvider.show();
    if(transaction.PayNowDetails){
      this.setPayNowPage(transaction, isShowExpiresAlert);
    } else{
      this.getTransactionByOderId(transaction, isShowExpiresAlert);
    }
    this.loadingProvider.hide();
  }

  setPayNowPage(transaction, isShowExpiresAlert){
    this.routeProvider.openModal(this.routeProvider.pages.SendPaymentPendingPayNow, { transaction: transaction, paymentMethod: transaction.PaymentMethod, isShowExpiresAlert: isShowExpiresAlert });
  }

  async getTransactionByOderId(transaction, isShowExpiresAlert){
    try{
      this.payNowTransaction = this.customersProvider.getTransaction(transaction.Id).subscribe(async result => {
        if (result) {
          this.setPayNowPage(result, isShowExpiresAlert);
          this.payNowTransaction.unsubscribe();
        }
      });
    }catch(e){
      this.loadingProvider.hide()
      LoggerProvider.exception(this, e, LoggerEvent.PageException, 'Failed to get paynow QR');
    }
  }

  hasBarcodeToShow(transaction, order: IOrder | null = null): boolean {
    return !!(order && order.additionalDetails && order.additionalDetails.externalBarcode) || !!(transaction && transaction.Barcode);
  }
  
  setBarcodeRoute(transaction, order: IOrder | null = null, fromChile: boolean = false, asModal: boolean = false) {
    if (order && order.additionalDetails && order.additionalDetails.externalBarcode) {
      this.openBarcodePage(this.routeProvider.pages.SendEpayBarcodePage, { transaction: transaction, order: order }, asModal);
      return;
    }
    this.homescreenProvider.paymentAgent = 'Ria';
    this.openBarcodePage(this.routeProvider.pages.SendBarcode, { transaction: transaction, fromChile: fromChile, order: order }, asModal);
  }

  private openBarcodePage(page, params, asModal: boolean) {
    if (asModal)
      this.routeProvider.openModal(page, params);
    else
      this.routeProvider.push(page, params);
  }

  payOrder(order: IOrder): Promise<any> {
    const request = OrderMapper.toCreateOrderRequestEntity(order);
    request.orderNumber = order.pspCreatedOrderNumber;
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}order/pay`, request);
  }

  delayOrderPost(modifyingOrderNumber: string, action: string): Promise<DelayedOrderPost> {
    return this.httpProvider.post(`${APP_CONFIG.remittanceApiBaseUrl}Order/SelfServiceInitiate`, {
      ModifyingOrderNumber: modifyingOrderNumber,
      SelfServiceAction: action
    });
  }

  shouldApplyVenezuelaRestriction(): boolean {
    return (
      this.order &&
      this.order.countryTo === 'VE' &&
      this.order.currencyTo === 'USD' &&
      this.order.deliveryMethodInternal === DeliveryMethodType.OfficePickup)
  }

  private getPaymentMethodType(paymentMethod: string) {
      if (paymentMethod === PaymentMethodType.BankAccount)
        return this.translate.instant('page.paymentAccountVerifyPage.bankAccountLabel');
      else if (paymentMethod === PaymentMethodType.DebitCard) 
        return this.translate.instant("page.paymentAccountDetailsPage.paymentMethods.debitCard");
      else if (paymentMethod === PaymentMethodType.CreditCard) 
        return this.translate.instant("page.paymentAccountDetailsPage.paymentMethods.creditCard");
  }

  public showGenericErrorModal(imagePath: String, title: String, msg: String, primaryButtonText: String, primaryButtonAction) {
    this.routeProvider.openActionSheetNew(this.routeProvider.pages.ModalAlertPage, {
      showFullPage: false,
      imageWithCircle: true,
      image: imagePath, 
      title: title, 
      msg: msg, 
      primaryButtonText: primaryButtonText, 
      primaryButtonAction: () => primaryButtonAction()
    });
  }

  getPayAmount(order) {
    return order.totalAmount + ' ' + order.currencyFrom;
  }

  async recalculateTotals(order, state) {
    await this.promoProvider.checkPromoEnginePromotions(order);
    const result = await this.calcProvider.calculateOrderTotals(this.resourceProvider, order, state);
    return result;
  }


  private getAgentName(agent: IAgent): string {
    if (agent.digitalAlias && agent.digitalAlias !== '') {
      return agent.digitalAlias;
    }

    if (agent.name) {
      return agent.name;
    }

    return '';
  }

  fillOrder(order, totals) {
    order.amountFrom = totals.amountFrom ? String(totals.amountFrom) : '';
    order.amountTo = totals.amountTo? String(totals.amountTo) : '';
    order.isPromoValid = totals.isPromoValid;
    order.sendAmountUSD = totals.sendAmountUSD;
    order.promoAmount = totals.promoAmount;
    order.customerFee = totals.transferFee;
    order.originalCustomerFee = totals.originalCustomerFee;
    order.totalAmount = totals.totalAmount? String(totals.totalAmount) : '';
    order.customerTax = totals.taxAmount;
    order.exchangeRate = totals.exchangeRate;
    order.primaryCurrency = totals.primaryCurrency;
    order.primaryExchangeRate = totals.primaryExchangeRate;
    order.primaryReceiveAmount = totals.primaryReceiveAmount;
    order.secondaryCurrency = totals.secondaryCurrency;
    order.secondaryExchangeRate = totals.secondaryExchangeRate;
    order.secondaryReceiveAmount = totals.secondaryReceiveAmount;
    order.correspondentPayoutFeeAmount = totals.correspondentPayoutFeeAmount;
    order.correspondentPayoutFeeCurrency = totals.correspondentPayoutFeeCurrency;
    order.estimatedAmountToAfterCorrespondentFees = totals.estimatedAmountToAfterCorrespondentFees;
  
    order.deliveryMethods = totals.deliveryMethods;
    order.variableRates = totals.variableRates;
    order.initialTotalAmount = totals.initialTotalAmount;

    order.totalFeesAndTaxes = totals.totalFeesAndTaxes;
    order.totalAmountUSD = totals.totalAmountUSD;
    order.customerFeeUSD = totals.transferFeeUSD;
    order.calculatedRatePromo = totals.calculatedRatePromo;
    order.variableFees = totals.variableFees;
    order.lastExchangeRate = order.exchangeRate;
    order.exchangeRatePromo = totals.exchangeRatePromo;
  }

  getDocUploadTrackProperty(isFromMalaysiaAndNonNational, transaction: Transaction) {
    let docuploadEventObj: any = {};
    let dataAnalytics;

    const order: IOrder = this.getCurrentOrder();
    let previousPage = this.routeProvider.getPreviousPageName();
    const objUploadDocumentInfo = this.getUploadDocumentInfo(isFromMalaysiaAndNonNational, transaction)

    docuploadEventObj.uploadReason = objUploadDocumentInfo.uploadReason;
    docuploadEventObj.uploadRequestNo = objUploadDocumentInfo.uploadRequestNo;
    docuploadEventObj.docsRequired = objUploadDocumentInfo.docsRequired;
    docuploadEventObj.docsWithStatus = objUploadDocumentInfo.docsWithStatus;
    docuploadEventObj.orderNo = transaction.OrderNo;
    docuploadEventObj.location = (previousPage == 'ActivityPage') ? SegmentLocationNames.Activity : (previousPage == 'SendReceiptPage') ? SegmentLocationNames.TransferDetails : SegmentLocationNames.SendMoney;
    docuploadEventObj.senderCountry = transaction.CountryFrom;
docuploadEventObj.destinationCountry = transaction.CountryTo;

    if(transaction && transaction.PaymentMethod) {
      dataAnalytics = this.getAnalyticsDataFromTransaction(transaction);
    }
    else {
      dataAnalytics = this.getAnalyticsDataFromOrder(order);
    }
    
    if(!docuploadEventObj.senderCountry)
      docuploadEventObj.senderCountry = APP_CONFIG.region.defaultCountryFrom;

    if(!docuploadEventObj.destinationCountry)
      docuploadEventObj.destinationCountry = order.countryTo;

    docuploadEventObj.paymentMethod = dataAnalytics.paymentMethod;
    docuploadEventObj.paymentVendor = dataAnalytics.paymentVendor || "";
    docuploadEventObj.payoutMethod = dataAnalytics.payoutMethod;

    return docuploadEventObj;
  }

  getDeliveryMethodImage(type) {
    var imageUrl = {
      //Delivery
      'BankDeposit': 'assets/icons/bank_delivery.svg',
      'OfficePickup': 'assets/icons/cash_pickup_delivery.svg',
      'HomeDelivery': 'assets/icons/home_delivery.svg',
      'MobilePayment': 'assets/icons/mobile_wallet_delivery_new.png',
      'SencillitoOnline': 'assets/icons/sencillito_delivery.svg',
      'UPI': 'assets/icons/upi.svg',
      'Alipay': 'assets/icons/alipay.svg',
      'PIX': 'assets/icons/pix.svg',
      'BreB': 'assets/icons/breb.svg',
      'PagoMovil': 'assets/icons/pago_movil.svg',
      'DebitCard': 'assets/icons/card_visa.svg',
    };

    if (imageUrl[type])
      return imageUrl[type];
    return 'assets/icons/cash_pickup_delivery.svg';
  }
  
  async findLastCardAccountInTransactions(order) {
    try {
      let paymentMethod = PaymentMethodTypeID.CreditCard;
      if (order && order.paymentMethod === PaymentMethodType.DebitCard)
        paymentMethod = PaymentMethodTypeID.DebitCard;
      const trxs = await this.customersProvider.getTransactionsGroupedByStatus(0, null, false, TransactionViewType.Condensed);
      for (let i=0; i < trxs.length; i++) {
        const trx = trxs[i];
        if (trx.PaymentMethod === paymentMethod) {
          let cardAccount = this.lastCardAccounts[order.paymentMethod];
          if (cardAccount && cardAccount.orderNumber === trx.OrderNo) {
            LoggerProvider.info(this, `Last card account order already in cache ${trx.OrderNo}`);
            return cardAccount;
          } else {
            cardAccount = null;
            const status = await this.getOrderStatus(trx.OrderNo);
            if (status && status.cardAccount) {
              LoggerProvider.info(this, `Found last used card account in transactions ${status.cardAccount.accountId}`);
              cardAccount = status.cardAccount;
              this.lastCardAccounts[order.paymentMethod] = {
                orderNumber: trx.OrderNo,
                ...cardAccount
              };
              return cardAccount;
            }
          }
          LoggerProvider.info(this, `Did not found fitting card account in transactions for order ${trx.OrderNo}`);
        }
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to check selected account in transaction');
    }
    return null;
  }

  getTransactObjectFromOrder(transact: Transaction) {
    
    if(this.order) {
      transact.OrderNo = this.order.orderNumber;
      transact.UploadRequestNo = this.order.uploadRequestNo;
      transact.UploadReason = this.order.uploadReason;
      transact.UploadDocTypes = this.order.uploadDocTypes;
      transact.UploadDocumentInfo = this.order.uploadDocumentInfo;
    }

    return transact;
  }

  showAddressAVSError() {
    if (this.paymentProvider.getAllowEditBillingAddress()) {
      const pspPage = this.routeProvider.getLastActivePageInstance()
      this.routeProvider.openActionSheetNew(this.routeProvider.pages.ModalAlertPage, {
        title: this.translate.instant('page.errorMessage.updateBillingAddressTitle'),
        subtitle: this.translate.instant('page.errorMessage.updateBillingAddressDescription'),
        showPrimaryButton: true,
        showSecondaryButton :true,
        primaryButtonText: this.translate.instant('global.editButton'),
        secondaryButtonText: this.translate.instant('global.closeButton'),
        primaryButtonAction: () => {
          LoggerProvider.info(this, 'Update billing address');
          pspPage.editBillingAddress();
        }
      });
    } else {
      this.routeProvider.openActionSheetNew(this.routeProvider.pages.ModalAlertPage, {
        title: this.translate.instant('page.errorMessage.updateBillingAddressTitle'),
        subtitle: this.translate.instant('page.errorMessage.updateBillingAddressDescription'),
        showPrimaryButton: true,
        primaryButtonText: this.translate.instant('global.okButton'),
      });
    }
  }
  
  showAddressAVSNotificationModal() {
    this.routeProvider.openActionSheetNew(this.routeProvider.pages.ModalAlertPage, {
      showFullPage: false,
      image: 'assets/icons/close-circle.svg',
      imageWithCircle: true,
      title: this.translate.instant('page.errorMessage.updateBillingAddressTitle'),
      subtitle: this.translate.instant('page.paymentConfirmationPage.AppleandGoogle.UpdateBillingAddressBody'),
      showPrimaryButton: true,
      primaryButtonText: this.translate.instant('global.okButton'),
    });
  }

  shouldDeferOrderCreatedEvents(order: IOrder): boolean {
    if (!order)
      return false;
    return order.paymentMethod === PaymentMethodType.DirectBank ||
      order.paymentMethod === PaymentMethodType.Giropay;
  }

  claimOrderCreatedEvents(order: IOrder): boolean {
    if (!order)
      return false;
    if (!order.orderNumber)
      return true;
    const orderNumber = `${order.orderNumber}`;
    if (this.trackedOrderNumbers.indexOf(orderNumber) > -1)
      return false;
    this.trackedOrderNumbers.push(orderNumber);
    return true;
  }

  getAdjustedTotalTransactionCount(transactionInfo: TransactionInfo) {
    let count = transactionInfo.totalTransactionCount;

    // if there are cancelled ACH orders we need to exclude them from the total transaction count otherwise it will have an incorrect count and harm first orders for ER 
    // (technically we create two transactions in an ER case but we have to treat it as one)
    // unfortunately we don't have the actual transaction ID but the transaction ID before and hence need to find out the actual transaction ID
    if (this.cancelledACHOrders && this.cancelledACHOrders.length > 0 && transactionInfo.transactions && transactionInfo.filteredTransactions && transactionInfo.filteredTransactions.length > 0) {
      let initialCount = count;
      LoggerProvider.info(this, 'Need to adjust total transaction count to remove cancelled ACH orders', this.cancelledACHOrders);

      let allTransactionsIds = [];
      for (const trx of transactionInfo.transactions) {
        allTransactionsIds.push(trx.Id);
      }
      for (const trx of transactionInfo.filteredTransactions) {
        allTransactionsIds.push(trx.Id);
      }
      allTransactionsIds.sort();

      if (allTransactionsIds.length > 0) {
        LoggerProvider.info(this, 'Check adjusted transaction count for following transaction IDs', allTransactionsIds);
        for (const id of this.cancelledACHOrders)
        {
          let cancelledId = 0;
          if (id === 0)
            cancelledId = allTransactionsIds[0];
          else
          {
            let inx = allTransactionsIds.indexOf(id) + 1;
            if (inx > 0 && inx < allTransactionsIds.length)
              cancelledId = allTransactionsIds[inx];
          }
          if (cancelledId > 0 && transactionInfo.filteredTransactions.find((trx) => trx.Id === cancelledId)) {
            LoggerProvider.info(this, `Removed transaction ${cancelledId} from count`);
            if (count > 0)
              count--;
          }
        }
        LoggerProvider.info(this, `Adjusted count from ${initialCount} to ${count}`);
      }
    }

    if (this.order && this.order.orderNumber && transactionInfo.transactions) {
      const initialCount = count;
      const trx = transactionInfo.transactions.find((trx) => (trx.OrderNo == this.order.orderNumber));
      if (trx) {
        count--;
        LoggerProvider.info(this, `Adjusted count from ${initialCount} to ${count} since order ${this.order.orderNumber} was part of transactions`);
      }
    }

    return count;
  }

  logDocUploadEvent(eventName, transaction, isFromMalaysiaAndNonNational, docName = null) {
    const docuploadTrackObj = this.getDocUploadTrackProperty(isFromMalaysiaAndNonNational, transaction) || {};

    const analyticsData: any = {
      'uploadReason': docuploadTrackObj.uploadReason,
      'transactionId': docuploadTrackObj.orderNo,
      'location': docuploadTrackObj.location,
      'senderCountry': docuploadTrackObj.senderCountry,
      'destinationCountry': docuploadTrackObj.destinationCountry,
      'paymentMethod': docuploadTrackObj.paymentMethod,
      'paymentVendor': docuploadTrackObj.paymentVendor,
      'payoutMethod': docuploadTrackObj.payoutMethod,
      ...(docuploadTrackObj.docsRequired && docuploadTrackObj.docsRequired.length && { docsRequired: docuploadTrackObj.docsRequired }),
      ...(docuploadTrackObj.uploadRequestNo && docuploadTrackObj.uploadRequestNo.length && { uploadRequestNo: docuploadTrackObj.uploadRequestNo })
    };

    if (this.isDocUploadCompletionEvent(eventName)) {
      analyticsData.uploadedDocumentSubtype = this.getUploadedDocumentSubtype(docuploadTrackObj, docName);
    }

    this.analytics.trackEvent({
      eventName: eventName,
      analyticsData: analyticsData
    });
  }
  
  getImageForPaymentMethod(order, method?:any) {
    let payImage = '';
    let switchMethod = order.paymentMethod;
    if (method) {
      switchMethod = method.type;
    }
    switch(switchMethod.toLowerCase()) {
      case PaymentMethodType.GooglePay.toLowerCase(): 
        payImage = 'assets/icons/trademarked/google-pay.svg';
        break;
      case PaymentMethodType.ApplePay.toLowerCase():
        payImage = 'assets/icons/trademarked/apple-pay.svg';
        break;
      case PaymentMethodType.GooglePayCredit.toLowerCase(): 
        payImage = 'assets/icons/trademarked/google-pay.svg';
        break;
      case PaymentMethodType.ApplePayCredit.toLowerCase():
        payImage = 'assets/icons/trademarked/apple-pay.svg';
        break;
      case PaymentMethodType.DirectBank.toLowerCase():
        payImage = this.getDirectBankImage(order);
        break;
      case DirectBankBrand.IDeal.toLowerCase():
        payImage = 'assets/icons/ideal.svg';
        break;
      case DirectBankBrand.AdyenBancontact.toLowerCase():
        payImage = 'assets/icons/bancontact.svg';
        break;
      case PaymentMethodType.OpenBanking.toLowerCase():
        payImage = 'assets/pay-by-bank/pay-by-bank-logo.svg';
        break;
      default:
        payImage = 'assets/psp/credit-card.svg';
        break;
    }
    
    return payImage;
  }

  getDirectBankImage(order) {
    if(order.pspPaymentMethod) {
      if(order.pspPaymentMethod.toLowerCase() === DirectBankBrand.IDeal.toLowerCase()) {
        return 'assets/icons/ideal.svg'
      }
      else if(order.pspPaymentMethod.toLowerCase() === DirectBankBrand.Bancontact.toLowerCase()) {
        return 'assets/icons/bancontact.svg'
      }
      else if(order.pspPaymentMethod.toLowerCase() === DirectBankBrand.AdyenBancontact.toLowerCase()) {
        return 'assets/icons/bancontact.svg'
      }
    }
  }

  getUploadDocumentInfo(isFromMalaysiaAndNonNational, transaction) {
    const objDocRequirements = {
      docsRequired: [],
      docsWithStatus: [],
      uploadRequestNo: [],
      uploadReason: "Transaction On Hold"
    };
  
    if (!transaction) 
      return objDocRequirements;
  
    const docList = transaction.UploadDocumentInfo;
    if (docList) {
      docList.forEach(doc => {
        if (doc.uploadDocType) {
          objDocRequirements.docsRequired.push(doc.uploadDocType);
          objDocRequirements.docsWithStatus.push({ type: doc.uploadDocType, status: doc.uploadRequestStatus || doc.UploadRequestStatus });
        }
        
        if (doc.uploadRequestNo)
          objDocRequirements.uploadRequestNo.push(doc.uploadRequestNo);
      });
    }
  
    if (objDocRequirements.docsRequired.length === 0 && transaction.UploadDocTypes)
      objDocRequirements.docsRequired.push(transaction.UploadDocTypes);
  
    if (objDocRequirements.uploadRequestNo.length === 0 && transaction.UploadRequestNo)
      objDocRequirements.uploadRequestNo.push(transaction.UploadRequestNo);
  
    return objDocRequirements;
  }

  async getPspRedirectResult(msg) {
    LoggerProvider.info(this, "ASWebAuthSession success : + " + msg);
    const pspRedirect = (typeof msg !== 'object') && (msg && msg.indexOf('/#/result-psp?') >= 0);
    if (!pspRedirect) {
      return null;
    }
    LoggerProvider.info(this, 'PSP redirect found');
    const order = await this.getPendingOrder();
    if (order) {
      let redirectResult;
      let queries = msg.split('?');
      if (queries && queries.length >= 2) {
        queries = queries[1].split('&');
        if (queries) {
          for (const part of queries) {
            if (part.indexOf('redirectResult=') === 0)
              redirectResult = decodeURIComponent(part.replace('redirectResult=', ''));
          }
        }
      }

      if (redirectResult) {
        return redirectResult;
      } else
        LoggerProvider.error(this, LoggerEvent.PageException, 'Incomplete result for PSP: ' + msg);
    } else
      LoggerProvider.error(this, LoggerEvent.PageException, 'Order missing for PSP !');
    return null;
  }

  async handlePspRedirect(redirectResult) {
    if (HttpProvider.hasAuthCustomerId()) {
      try {
        if (!this.pspRedirectResultHandled) {
          this.pspRedirectResultHandled = true;
          const order = await this.getPendingOrder();
          this.setCurrentOrder(order, false);
          this.removePendingOrder();
          const redirectOrder = { ...order };
          redirectOrder.pspPaymentSessionData = {
            data: redirectResult,
            additionalDetails: true
          };
          LoggerProvider.info(this, 'Navigate back to PSP');
          const createOrderPromise = this.createOrder(redirectOrder);
          await this.routeProvider.replace(this.routeProvider.pages.SendFinishPage, { createOrderPromise, order: redirectOrder, pendingPayment: true, isSendAgain: order.resend });
          this.has3dsRedirect = false;
        } else {
          LoggerProvider.error(this, LoggerEvent.PageException, 'PSP redirect already handled');
          this.has3dsRedirect = false;
        }
        this.has3dsRedirect = false;
      } catch (e) {
        LoggerProvider.exception(this, e, LoggerEvent.PageException, 'Failed to handle PSP redirect');
        this.has3dsRedirect = false;
      }
    }
    this.loadingProvider.hide();
  }

  async findLastTransactionByBeneficiary(benID) { 
        return this.httpProvider.get(`${APP_CONFIG.API_URL}api/${benID}/lastcustomertransaction`)
  }

  private isDocRequiredAndOpen(docsRequired: string[], docsWithStatus: { type: string; status: string }[], docType: string) {
    if (!docsRequired.includes(docType)) return false;
    if (!docsWithStatus || docsWithStatus.length === 0) return true;
    const doc = docsWithStatus.find(d => d.type === docType);
    return doc && doc.status === DocUploadStatus.Open;
  }

  private isDocUploadCompletionEvent(eventName: string): boolean {
    return eventName === AnalyticsEventType.DocUploadCompleted || eventName === AnalyticsEventType.DocUploadSubmittedFailed;
  }

  private getUploadedDocumentSubtype(docuploadTrackObj: any, docName: string): string[] | string {
    const { docsRequired, docsWithStatus } = docuploadTrackObj;

    if (!docsRequired || docsRequired.length === 0)
      return docName;

    const subtypes = [];

    const isProofOfMoneyRequired = this.isDocRequiredAndOpen(docsRequired, docsWithStatus, DocUploadType.ProofOriginOfMoney);
    const isCopyOfVisaRequired = this.isDocRequiredAndOpen(docsRequired, docsWithStatus, DocUploadType.CopyOfVisa);

    if (isProofOfMoneyRequired)
      subtypes.push(this.proofOfFundsDocName);

    if (isCopyOfVisaRequired)
      subtypes.push(DocUploadType.CopyOfVisa);

    return subtypes;
  }
}



// WEBPACK FOOTER //
// ./src/providers/order/order.ts